<div class="container pb-50 pt-70" id="profile-tabs">
  <app-article [pageName]="'TEACHER_PROFILE'" (pageTeacherDataLoaded)="handlePageData($event)"></app-article>
  @if(showOnboarding){
  <div class="profile_onboarding" *ngIf="isOnboardingIncomplete">
    <div class="row">
      <div class="col-md-9 col-lg-9 col-sm-12">
        <h1 class="user-title fs-18">Set up your profile</h1>
        <p class="txt-regular mt-10">
          Complete these steps to get more bookings. On average completed
          profile see upto 30% more bookings.
        </p>
        <div class="track__onboarding d-flex align-items-center mt-20">
          <ng-container *ngFor="let step of [1, 2, 3, 4]; let i = index">
            <div class="onboarding-bar" [ngClass]="{
      completed: onboardingStep > i + 1,
      active: onboardingStep === i + 1
    }">
              <ng-container *ngIf="i === 3">
                <span class="tick-circle" [ngClass]="{ completed: onboardingStep > 4 }">
                  <svg *ngIf="onboardingStep > 4" width="24" height="24" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" fill="#18C864" />
                    <polyline points="8 12 11 15 16 10" fill="none" stroke="#fff" stroke-width="2" />
                  </svg>
                </span>
              </ng-container>
            </div>
            <div *ngIf="i < 3" style="width: 12px"></div>
          </ng-container>
        </div>
        <p class="txt-regular fs-12">{{ onboardingStep - 1 }}/4 Steps</p>
        <div class="mt-20">
          <h1 class="user-title fs-18">Add your personal information</h1>
          <p class="txt-regular mt-10">
            Adding your personal information to your profile is an essential
            step in completing your profile and making it stand out to schools
          </p>
        </div>
        <div class="next_prev_on d-flex align-items-center mt-20">
          <a role="button" class="txt-regular fs-12 d-flex align-items-center" (click)="goToNextStep()">
            <span class="mr-2">Next</span>
            <svg width="13" height="9" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l5 6a.5.5 0 0 1 0 .708l-5 6a.5.5 0 0 1-.708-.708L9.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-12"></div>
  </div>
  }
  <ul class="nav nav-tabs mb-4" id="profileTab" role="tablist">

    <li class="nav-item" role="presentation">
      <button appFocus class="nav-link active" id="personal-tab" data-bs-toggle="tab" data-bs-target="#personal"
        type="button" role="tab" aria-controls="personal" aria-selected="true"
        aria-label="Personal information tab 1 of 6">
        Personal information
      </button>
    </li>

    <li class="nav-item" role="presentation">
      <button appFocus class="nav-link" id="bookings-tab" data-bs-toggle="tab" data-bs-target="#bookings" type="button"
        role="tab" aria-controls="bookings" aria-selected="false" aria-label="Bookings tab 2 of 6">
        Bookings
      </button>
    </li>

    <li class="nav-item" role="presentation">
      <button appFocus class="nav-link" id="skills-tab" data-bs-toggle="tab" data-bs-target="#skills" type="button"
        role="tab" aria-controls="skills" aria-selected="false" aria-label="Skills and work experience tab 3 of 6">
        Skills and Work experience
      </button>
    </li>

    <li class="nav-item" role="presentation">
      <button appFocus class="nav-link" id="qualification-tab" data-bs-toggle="tab" data-bs-target="#qualification"
        type="button" role="tab" aria-controls="qualification" aria-selected="false"
        aria-label="Qualification and documents tab 4 of 6">
        Qualification and Documents
      </button>
    </li>

    <li class="nav-item" role="presentation">
      <button appFocus class="nav-link" id="references-tab" data-bs-toggle="tab" data-bs-target="#references"
        type="button" role="tab" aria-controls="references" aria-selected="false" aria-label="References tab 5 of 6">
        References
      </button>
    </li>

    <li class="nav-item" role="presentation">
      <button appFocus class="nav-link" id="availability-tab" data-bs-toggle="tab" data-bs-target="#availability"
        type="button" role="tab" aria-controls="availability" aria-selected="false"
        aria-label="Availability to work tab 6 of 6">
        Availability to work
      </button>
    </li>

  </ul>
  <div class="tab-content" id="profileTabContent">
    <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
      <!-- Personal information content here -->
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex">
            <div class="pic-and-check ml-0">
              <div class="pic-and-check ml-0">
                <img alt="img" [src]="
                    profileData?.meta.profile_image
                      ? profileData?.meta.profile_image
                      : '../../../../assets/images/teacher-static-profile.png'
                  " class="profile-picture img-complete-match" />
              </div>
            </div>
            <div class="pic-and-check ml-10">
              <div class="d-flex">
                <p>
                  <a role="button" aria-label="Teacher Profile Info" class="user-title fs-18">{{
                    profileData?.user.full_name }}</a>
                  <app-profile-validated-dict from="teacherProfile"
                    [validateDict]="profileData?.teacher_properties?.nsw_data?.doe_details"></app-profile-validated-dict>
                </p>
              </div>
              <p class="text-regular-medium fs-12 clr-green">
                {{ profileData?.percentage_mandatory?.profile_percentage }}%
                Profile Completed
              </p>
              <p class="text-r-18">
                @if(profileData?.consumer_type?.tags){
                <span> {{ profileData?.consumer_type?.tags }}</span>
                }@else {
                <span class="txt-regular "> Update role type</span>
                }
                <svg (click)="openRoleTypeModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
                  fill="currentColor" class="bi bi-pencil-fill ml-5 c-p" viewBox="0 0 16 22">
                  <path
                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </p>
              <p class="txt-regular">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" stroke-width="1"
                  class="bi bi-telephone" viewBox="0 0 15 19">
                  <path
                    d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                </svg>
                {{ profileData?.phone }}
                <span class="divider-right ml-3 mr-5"> </span>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" fill="currentColor"
                    class="bi bi-person" viewBox="0 0 15 20" stroke-width="1">
                    <path
                      d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                  </svg>
                  {{ profileData?.user.email }}
                </span>
              </p>
              <p class="txt-regular"
                *ngIf="profileData?.address?.city && profileData?.address?.address_timezone?.state">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" fill="currentColor" stroke-width="1"
                  class="bi bi-geo-alt" viewBox="0 0 15 19">
                  <path
                    d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                  <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                </svg>
                {{ profileData?.address?.city }}
                {{ profileData?.address?.address_timezone?.state }}
              </p>

              <button type="button" (click)="openEditProfileModal()" class="btn cc_p_btn fs_13 mt-15">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-pencil-fill" viewBox="0 0 16 20">
                  <path
                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
                Edit Profile
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Teacher portfolio card hidden for now
      @if(!isOnboardingIncomplete){
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="d-flex align-items-center s_between">
              <div class="job__alerts switch-green d-flex align-items-center">
                <label class="text-regular-medium fs-16 mr-10 mb-0" for="turn-on-teacher-portfolio">Turn on Teacher
                  Portfolio</label>
                <div class="mr-10">
                  <div class="form-check form-switch p-0">
                    <input type="checkbox" role="switch" id="turn-on-teacher-portfolio"
                      class="form-check-input delay-send form__switch_cc ml-0 c-p" [(ngModel)]="public_profile_show"
                      name="turnOnTeacherPortfolio" [checked]="public_profile_show"
                      (change)="onPublicProfileShowChange($event)" />
                  </div>
                </div>
              </div>
              @if( public_profile_show ) {
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" stroke="#3A0CA3"
                  stroke-width="1" class="bi bi-eye" viewBox="0 0 16 17">
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                </svg>
                <a href="{{ this.profileData.public_profile_url }}" target="_blank"
                  class="user-title fs-15 clr-cc-vilot ml-5">Preview my portfolio</a>
              </div>
              }
            </div>
            <div class="col-md-12 col-sm-12 mt-5">
              <p class="txt-regular">
                Once turned on, you can share your teacher portfolio link with
                schools.
              </p>
            </div>
            @if( public_profile_show ) {
            <div class="col-md-12 col-sm-12 mt-5">
              <a class="a-link fs-14 c-p" href="{{ this.profileData.public_profile_url }}" target="_blank">{{
                this.profileData.public_profile_url
                }}</a>
            </div>
            }
          </div>
        </div>
      </div>
      }
      -->
      <div class="card px-15 mt-16">
        <div class="d-flex s_between align-items-center">
          <div class="d-flex">
            <h5 class=" ul-title mb-0">Video Introduction
            </h5>
            <span class="badge-new ml-10">New⚡</span>
          </div>
          <div class="d-flex justify-content-end" *ngIf="introVideo?.id">
            <span class="c-p text-regular-bold clr-cc-vilot" (click)="openVideoModal(introVideo?.id)"><i
                class="bi bi-pencil-square fs-20 mx-10 c-p"></i> </span>
            <i class="bi bi-x-circle-fill fs-20  clr-cc-vilot c-p ml-20"
              (click)="openIntroVideoRemoveConfirmation()"></i>
          </div>
        </div>
        <ng-container *ngIf="introVideo?.id; else addVideoPrompt">
          <div class="row justify-content-center align-items-center text-center p-20">
            <div class="col-lg-12">
              <app-video-player [videoMeta]="introVideo"></app-video-player>
            </div>
          </div>
        </ng-container>
        <ng-template #addVideoPrompt>
          <div class="row justify-content-center align-items-center text-center p-20">
            <div class="col-lg-9 col-md-9 col-sm-10 col-xs-9 col-9">
              <img width="120" src="assets/images/NoResultFound/preConfirm/addCasuals.png" />
            </div>
            <p class="txt-regular">Add a short video introducing yourself to schools that might want to work with you
            </p>
            <button class="cc_p_btn_outline fs_13 ml-10 mt-10 fit-content" (click)="openVideoModal('')">
              Add video
            </button>
          </div>
        </ng-template>
      </div>
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Status</h1>

            <button type="button" class="icon-btn" (click)="openEditStatusModal()" aria-label="Edit status">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" fill="#3A0CA3" class="bi bi-pencil-fill"
                viewBox="0 0 16 22" aria-hidden="true" focusable="false">
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
              </svg>
            </button>
          </div>
          @if (profileData?.meta.status) {
          <div class="col-md-12 col-lg-12 mt-15">
            <p class="txt-regular">{{ profileData?.meta.status }}</p>
          </div>
          }
        </div>
      </div>
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Accreditation</h1>
            <!-- <svg (click)="openEditAccreditationModal('')" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg> -->
            <button (click)="openEditAccreditationModal('')" type="button" class="icon-btn"
              aria-label="Add accreditation">
              <svg class="c-p" xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="#3A0CA3" stroke="#3A0CA3"
                class="bi bi-plus-lg" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
              </svg>
            </button>

          </div>
          @if(profileData?.accreditations && profileData?.accreditations.length
          > 0) {
          <div class="mt-15">
            @for (item of profileData?.accreditations; track item; let i =
            $index) {
            <div class="col-md-12 col-lg-12 mt-10">
              <div class="d-flex align-items-center s_between">
                <div class="d-flex">
                  <div class="envelope-icon mb-0">
                    <span class="txt-regular grey-4 mr-5">Accreditation Name:</span>
                    <span class="txt-regular">
                      {{ item.accreditation_name }}
                    </span>
                  </div>
                  <span class="divider-right ml-10 mr-10"> </span>
                  <div class="envelope-icon mb-0">
                    <span class="txt-regular grey-4 mr-5">Accreditation Number:</span>
                    <span class="txt-regular">
                      {{ item.accreditation_id }}
                    </span>
                  </div>
                  <span class="divider-right ml-10 mr-10"> </span>
                  <div class="envelope-icon mb-0">
                    <span class="txt-regular grey-4 mr-5">Accreditation Expiry Date:</span>
                    <span class="txt-regular">
                      {{ item.expiry_date }}
                    </span>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <svg (click)="openEditAccreditationModal(item, i)" xmlns="http://www.w3.org/2000/svg" width="16"
                    height="21" fill="#3A0CA3" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                    <path
                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                  </svg>
                  <svg (click)="removeRow('remove_accreditation', i)" xmlns="http://www.w3.org/2000/svg" fill="#3A0CA3"
                    stroke="#3A0CA3" width="25" height="25" class="bi bi-x-circle ml-10 c-p" viewBox="0 0 16 22">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                  </svg>
                </div>
              </div>
            </div>
            <hr>
            }
          </div>
          }
        </div>
      </div>
      @if(profileData?.qld_data){
      <div class="card mt-15 px-20" *ngIf="
    profileData?.meta?.emergency_contact?.emergency_contact_name1 ||
    profileData?.meta?.emergency_contact?.emergency_contact_phone1 ||
    profileData?.meta?.emergency_contact?.emergency_contact_name2 ||
    profileData?.meta?.emergency_contact?.emergency_contact_phone2
  ">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Emergency Contact Details</h1>
            <svg (click)="openEditProfileModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </div>
          <div class="col-md-12 col-lg-12 mt-15">
            <div class="envelope-icon mb-2">
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact name 1:
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_name1 }}</span>
                <!-- <span class="emergency-tag ms-2" *ngIf="profileData?.meta?.emergency_contact?.emergency_contact_relation1">{{profileData?.meta?.emergency_contact?.emergency_contact_relation1}}</span> -->
              </div>
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact phone 1:
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_phone1 }}</span>
              </div>
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Relationship:
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_relation1 }}</span>
              </div>
            </div>
            <div class="envelope-icon mb-2">
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact name 2:
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_name2 }}</span>
                <!-- <span class="emergency-tag ms-2" *ngIf="profileData?.meta?.emergency_contact?.emergency_contact_relation2">{{profileData?.meta?.emergency_contact?.emergency_contact_relation2}}</span> -->
              </div>
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact phone 2:
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_phone2 }}</span>
              </div>
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Relationship:
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_relation2 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      <!-- <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Emergency Contact Details</h1>
            <svg (click)="openEditProfileModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </div>
          <div class="col-md-12 col-lg-12 mt-15">
            <div class="envelope-icon mb-2">
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact 1 name
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_name1 }}</span>
              </div>
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact 1 phone
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_phone1 }}</span>
              </div>
            </div>
            <div class="envelope-icon mb-2">
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact 2 name
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_name2 }}</span>
              </div>
              <div>
                <span class="txt-regular grey-4 mr-5">
                  Emergency contact 2 phone
                </span>
                <span class="txt-regular">{{ profileData?.meta?.emergency_contact?.emergency_contact_phone2 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <ng-container *ngIf="teachLocalData?.properties?.is_qld_teacher || this.profileData?.address?.address_timezone?.state == 'Queensland'"> -->
      @if(showQldSection){
      @if((profileData?.qld_data?.work_status == 'S' || profileData?.qld_data?.status == 'NM' ||
      profileData?.qld_data?.status == 'C' || profileData?.qld_data?.status == 'E' || profileData?.qld_data?.status ==
      'L' || profileData?.qld_data?.status == 'P' || profileData?.qld_data?.status == 'DA' ||
      profileData?.qld_data?.status == 'Q') && profileData?.address?.address_timezone?.state == 'Queensland')
      {
      <div class="card px-15 mt-15">
        <h1 class="user-title fs-18">
          Verify your profile with the Queensland Department of Education <span
            *ngIf="profileData?.qld_data?.status == 'C' || profileData?.qld_data?.status == 'NM' || profileData?.qld_data?.status == 'L'"
            class="status_qld_verification {{profileData?.qld_data?.status}} ml-10"> {{profileData?.qld_data?.status
            == 'C' ? 'Conflict account' : 'Details not found' }} </span>
        </h1>
        <div class=" d-flex align-items-center s_between">
          <p class="txt-regular mt-15">
            To verify your profile with the Department of Education, you must have a current active application with
            <a href="https://teach.qld.gov.au/" target="_blank" class="text-regular-bold clr-cc-vilot text-center c-p">
              Teach Queensland</a> & current registration with Queensland College of Teacher (QCT). Please verify these
            now.
          </p>
          @if(profileData?.qld_data?.status != 'L') {
          <button type="button" (click)="openQLDVerificationModal()" class="btn cc_p_btn  pl-25 pr-25 fs_13 mt-10">
            Verify
          </button>
          }@else{
          @if(profileData?.qld_data?.employee_details?.is_help_request_sent) {
          <span class="mt-5 clr-green text-regular-bold d-flex align-items-center"><i
              class="bi bi-check2 fs-16 mt-1 me-1"></i> Request sent</span>
          }@else{
          <button type="button" (click)="ReqTracerHelper()" class="btn cc_p_btn fs_13 req-tracer-btn">Contact
            Support</button>
          }
          }
        </div>
        <!-- @if(profileData?.qld_data?.status == 'NM' || profileData?.qld_data?.status == 'E') {
            <p class="text-danger fs-13">Your QCT registration status is marked as "{{
              profileData?.qld_data?.qct_registration == 'NM' ? 'Not Matched' : 'Exception'}}". <br />
              Please review your registration details and re-register with QCT to ensure compliance.
            </p>
            } -->
      </div>
      }@else if(profileData?.qld_data?.role_type && profileData?.address?.address_timezone?.state == 'Queensland'){
      <app-qld-profile-completion [profileData]="profileInfo" [action]="action"
        (trigger)="handleChildEvent($event)"></app-qld-profile-completion>
      }
      }
      <!-- </ng-container> -->
      @if(profileData?.bce_data?.bce_work_status == "Y" || profileData?.bce_data?.bce_work_status == "N" ||
      profileData?.bce_data?.bce_work_status == "S" ||
      profileData?.address?.address_timezone?.state === "New South Wales" ) {
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Brisbane Catholic Education School</h1>
            <svg (click)="openBceModal(profileData?.bce_data.bce_work_status, '')" xmlns="http://www.w3.org/2000/svg"
              width="16" height="21" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </div>
          <div class="mt-20 d-flex align-items-center">
            <p class="text-regular-medium mr-20">
              Are you planning to work in Brisbane Catholic Education Schools?
            </p>
            <div class="form-check">
              <input class="form-check-input mt-4" type="radio" id="bce_yes" name="bce_work_status" [value]="'Y'"
                [checked]="bce_work_status === 'Y'" (change)="openBceModal('Y', '')" />
              <label class="form-check-label" for="bce_yes">Yes</label>
            </div>
            <div class="form-check ml-10">
              <input class="form-check-input mt-4" type="radio" id="bce_no" name="bce_work_status" [value]="'N'"
                [checked]="bce_work_status === 'N'" (change)="openBceModal('N', '')" />
              <label class="form-check-label" for="bce_no">No</label>
            </div>
          </div>
          <div>
            <p class="txt-regular">
              I’m willing to work in Brisbane Catholic Education Schools.
            </p>
            <a href="https://www.bne.catholic.edu.au/" target="_blank" class="a-link mt-5 fs-14">Learn more</a>
          </div>
          @if(profileData?.bce_data.bce_work_status == "Y"){
          <div class="bce_question">
            <div class="bce_question">
              <div class="bce_question">
                <div class="accordion" id="bceAccordion">
                  <!-- Mandatory questions -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="mandatoryHeading">
                      <button class="accordion-button grey-2 text-regular-bold" type="button" data-bs-toggle="collapse"
                        data-bs-target="#mandatoryCollapse" aria-expanded="true" aria-controls="mandatoryCollapse">
                        Mandatory questions
                        <span class="">
                          <!-- Down arrow SVG -->
                          <svg width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill ms-2"
                            viewBox="0 0 16 16">
                            <path
                              d="M7.247 11.14l-4.796-5.481C1.825 5.21 2.16 4.5 2.813 4.5h10.374c.653 0 .988.71.362 1.159l-4.796 5.481a1 1 0 0 1-1.506 0z" />
                          </svg>
                        </span>
                      </button>
                    </h2>
                    <div id="mandatoryCollapse" class="accordion-collapse collapse show"
                      aria-labelledby="mandatoryHeading">
                      <div class="accordion-body p-0">
                        <!-- Mandatory questions content here -->
                        <p class="txt-regular mt-5">
                          Location preferences:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta
                            ?.prefered_location
                            }}</span>
                        </p>
                        @if(this.profileData?.bce_data?.meta?.card_type == 'blueCard') {
                        <p class="txt-regular mt-5">
                          Blue card number:<span class="text-regular-bold">
                            {{ this.profileData?.bce_data?.blue_card_id }}</span>
                        </p>
                        }
                        @if(this.profileData?.bce_data?.meta?.card_type == 'QCT') {
                        <p class="txt-regular mt-5">
                          QCT number:<span class="text-regular-bold">
                            {{ this.profileData?.bce_data?.qct_id }}</span>
                        </p>
                        }
                        @if(this.profileData?.bce_data?.meta?.card_type == 'blueCard') {
                        <p class="txt-regular mt-5">
                          Type of blue card:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.blue_card_type
                            }}</span>
                        </p>
                        }
                        @if(this.profileData?.bce_data?.meta?.card_type == 'blueCard') {
                        <p class="txt-regular mt-5">
                          Expiry date:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.expiry_date
                            }}</span>
                        </p>
                        }
                        <p class="txt-regular mt-5">
                          Personal email:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.personal_email
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Right to work:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.right_to_work
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          CV:
                          <span class="text-regular-bold">
                            <a href="{{ this.profileData?.bce_data?.file }}">{{
                              this.profileData?.bce_data?.file
                              }}</a></span>
                        </p>
                        <p class="txt-regular mt-5">
                          What interests you about working for BCE:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.about_interest
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          What roles are you interested in:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.interested_role
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Safeguarding questions -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="safeguardingHeading">
                      <button class="accordion-button collapsed grey-2 text-regular-bold" type="button"
                        data-bs-toggle="collapse" data-bs-target="#safeguardingCollapse" aria-expanded="false"
                        aria-controls="safeguardingCollapse">
                        Safeguarding questions
                        <span class="">
                          <!-- Down arrow SVG -->
                          <svg width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill ms-2"
                            viewBox="0 0 16 16">
                            <path
                              d="M7.247 11.14l-4.796-5.481C1.825 5.21 2.16 4.5 2.813 4.5h10.374c.653 0 .988.71.362 1.159l-4.796 5.481a1 1 0 0 1-1.506 0z" />
                          </svg>
                        </span>
                      </button>
                    </h2>
                    <div id="safeguardingCollapse" class="accordion-collapse collapse"
                      aria-labelledby="safeguardingHeading">
                      <div class="accordion-body p-0">
                        <!-- Safeguarding questions content here -->
                        <p class="txt-regular mt-5">
                          Have you been issued a negative notice (Blue
                          card)?:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.negative_notice
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Have you ever had your QCT registration or Blue card
                          suspended?:
                          <span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta
                            ?.suspended_registration
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Have you ever abused, exploited or neglected a child
                          or vulnerable adult?:<span class="text-regular-bold">
                            {{ this.profileData?.bce_data?.meta?.abused }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Have you ever been accused of offences relating to a
                          child or vulnerable adult?:<span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.accused
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Have you ever been the subject of a substantiated
                          complaint, or convicted of an offence relating to a
                          child or vulnerable adult?:
                          <span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.substantiated
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Have you currently the subject of a criminal legal
                          proceeding, including police charges, for an offence
                          relating to child or vulnerable adult?:
                          <span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.criminal
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Are the responses you have provided to these questions
                          true and correct?:
                          <span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.all_questions
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Multiple choice questions -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="multipleChoiceHeading">
                      <button class="accordion-button collapsed grey-2 text-regular-bold" type="button"
                        data-bs-toggle="collapse" data-bs-target="#multipleChoiceCollapse" aria-expanded="false"
                        aria-controls="multipleChoiceCollapse">
                        Multiple choice questions
                        <span class="">
                          <!-- Down arrow SVG -->
                          <svg width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill ms-2"
                            viewBox="0 0 16 16">
                            <path
                              d="M7.247 11.14l-4.796-5.481C1.825 5.21 2.16 4.5 2.813 4.5h10.374c.653 0 .988.71.362 1.159l-4.796 5.481a1 1 0 0 1-1.506 0z" />
                          </svg>
                        </span>
                      </button>
                    </h2>
                    <div id="multipleChoiceCollapse" class="accordion-collapse collapse"
                      aria-labelledby="multipleChoiceHeading">
                      <div class="accordion-body p-0">
                        <!-- Multiple choice questions content here -->
                        <p class="txt-regular mt-5">
                          Teaching levels:
                          <span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.teachingLevels
                            }}</span>
                        </p>
                        <p class="txt-regular mt-5">
                          Subjects:
                          <span class="text-regular-bold">
                            {{
                            this.profileData?.bce_data?.meta?.subject
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }
      @if(profileData?.teacher_properties?.nsw_data?.doe_work_status == "S" ||
      profileData?.teacher_properties?.nsw_data?.doe_work_status == "Y") {
      <div class="card px-15 mt-15">
        <h1 class="user-title fs-18">
          Verify to work with NSW Department of Education
        </h1>
        <div>
          <p class="txt-regular mt-15">
            If you are currently working in or are looking for work in NSW Public Schools, you need to verify your
            profile.
          </p>
        </div>
        <div class="">
          <button type="button" (click)="openNSWVerificationModal()" class="btn-outline pl-25 pr-25 fs_13 mt-10">
            Verify
          </button>
        </div>
      </div>
      }
      <div class="card px-15 mt-15" *ngIf="profileData?.address?.address_timezone?.state === 'Queensland'">
        <h1 class="user-title fs-18">
          Cairns Catholic Education School
        </h1>
        <div>
          <div class="mt-20 d-flex align-items-center">
            <p class="text-regular-medium mr-20">
              Are you planning to work in Cairns Catholic Education School?
            </p>
            <div class="form-check">
              <input class="form-check-input mt-4" type="radio" id="workGroupYes_Cairns"
                name="plan_to_work_group_Cairns" [value]="true" [(ngModel)]="plan_to_work_group"
                (ngModelChange)="onPlanToWorkGroupChange($event)" />
              <label class="form-check-label" for="workGroupYes_Cairns">Yes</label>
            </div>
            <div class="form-check ml-10">
              <input class="form-check-input mt-4" type="radio" id="workGroupNo_Cairns" name="plan_to_work_group_Cairns"
                [value]="false" [(ngModel)]="plan_to_work_group" (ngModelChange)="onPlanToWorkGroupChange($event)" />
              <label class="form-check-label" for="workGroupNo_Cairns">No</label>
            </div>

          </div>
          <div *ngIf="plan_to_work_group == true">
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="form-group mb-2 mt-15">
                  <label>CNS Payroll ID</label>
                  <input type="text" class="form-control" name="custom_fields_Cairns_0_CNS"
                    [(ngModel)]="custom_fields_Cairns_0_CNS" placeholder="Please add your response">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="form-group mb-2">
                  <label>Previous Surname</label>
                  <input type="text" class="form-control" name="custom_fields_Cairns_0_Previous"
                    [(ngModel)]="custom_fields_Cairns_0_Previous" placeholder="Please add your response">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="form-group mb-2">
                  <label>Alternative Work Email Address</label>
                  <input type="text" class="form-control" name="custom_fields_Cairns_0_Alternative"
                    [(ngModel)]="custom_fields_Cairns_0_Alternative" placeholder="Please add your response">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="">
                <button type="button" (click)="saveCairnsData()" class="btn-outline pl-25 pr-25 fs_13 mt-10">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if(profileData?.teacher_properties?.nsw_data?.doe_work_status == "D" &&
      profileData?.teacher_properties?.nsw_data?.doe_details.is_teacher == true) {
      <div class="card px-15 mt-15">
        <h1 class="user-title fs-18">
          Verify to work with NSW Department of Education
        </h1>
        <p class="txt-regular mt-5">
          Nesa ID:
          <span class="text-regular-bold">
            {{profileData?.teacher_properties?.nsw_data?.doe_details.nesa_id}}
          </span>
        </p>
        <p class="txt-regular mt-5">
          First Name:
          <span class="text-regular-bold">
            {{profileData?.teacher_properties?.nsw_data?.doe_details.first_name}}
          </span>
        </p>
        <p class="txt-regular mt-5">
          Last Name:
          <span class="text-regular-bold">
            {{profileData?.teacher_properties?.nsw_data?.doe_details.last_name}}
          </span>
        </p>
        <p class="txt-regular mt-5">
          Date of Birth:
          <span class="text-regular-bold">
            {{profileData?.teacher_properties?.nsw_data?.doe_details.dob}}
          </span>
        </p>

        <div class="">
          <button type="button" (click)="openNSWVerificationUpdateModal()" class="btn-outline pl-25 pr-25 fs_13 mt-10">
            Update
          </button>
        </div>
      </div>
      }
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">
              Right to work in Australia or New Zealand
            </h1>
            <button (click)="openRightsToWorkModal()" type="button" aria-label="Right to work edit">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" fill="currentColor"
                class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
              </svg>
            </button>
          </div>
          <div class="col-md-12 col-lg-12 mt-15">
            <div class="envelope-icon mb-0">
              <span class="txt-regular grey-4 mr-5">Right to work:</span>
              <span class="txt-regular">
                {{ profileData?.meta.right_to_work }}
              </span>
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <div class="envelope-icon mb-0">
              <span class="txt-regular grey-4 mr-5">Start date:</span>
              <span class="txt-regular">
                {{ profileData?.meta.work_start_date }}
              </span>
            </div>
          </div>
        </div>
      </div>
      @if(showQldSection){
      @if((profileData?.qld_data?.work_status == 'S' || profileData?.qld_data?.status == 'NM' ||
      profileData?.qld_data?.status == 'C' || profileData?.qld_data?.status == 'E' || profileData?.qld_data?.status ==
      'L' || profileData?.qld_data?.status == 'P' || profileData?.qld_data?.status == 'DA' ||
      profileData?.qld_data?.status == 'Q') && profileData?.address?.address_timezone?.state !== 'Queensland')
      {
      <div class="card px-15 mt-15">
        <h1 class="user-title fs-18">
          Verify your profile with the Queensland Department of Education <span
            *ngIf="profileData?.qld_data?.status == 'C' || profileData?.qld_data?.status == 'NM' || profileData?.qld_data?.status == 'L'"
            class="status_qld_verification {{profileData?.qld_data?.status}} ml-10"> {{profileData?.qld_data?.status
            == 'C' ? 'Conflict account' : 'Details not found' }} </span>
        </h1>
        <div class=" d-flex align-items-center s_between">
          <p class="txt-regular mt-15">
            To verify your profile with the Department of Education, you must have a current active application with
            <a href="https://teach.qld.gov.au/" target="_blank" class="text-regular-bold clr-cc-vilot text-center c-p">
              Teach Queensland</a> & current registration with Queensland College of Teacher (QCT). Please verify these
            now.
          </p>
          @if(profileData?.qld_data?.status != 'L') {
          <button type="button" (click)="openQLDVerificationModal()" class="btn cc_p_btn  pl-25 pr-25 fs_13 mt-10">
            Verify
          </button>
          }@else{
          @if(profileData?.qld_data?.employee_details?.is_help_request_sent) {
          <span class="mt-5 clr-green text-regular-bold d-flex align-items-center"><i
              class="bi bi-check2 fs-16 mt-1 me-1"></i> Request sent</span>
          }@else{
          <button type="button" (click)="ReqTracerHelper()" class="btn cc_p_btn fs_13 req-tracer-btn">Contact
            Support</button>
          }
          }
        </div>
        <!-- @if(profileData?.qld_data?.status == 'NM' || profileData?.qld_data?.status == 'E') {
            <p class="text-danger fs-13">Your QCT registration status is marked as "{{
              profileData?.qld_data?.qct_registration == 'NM' ? 'Not Matched' : 'Exception'}}". <br />
              Please review your registration details and re-register with QCT to ensure compliance.
            </p>
            } -->
      </div>
      }@else if(profileData?.qld_data?.role_type && profileData?.address?.address_timezone?.state !== 'Queensland'){
      <app-qld-profile-completion [profileData]="profileInfo" [action]="action"
        (trigger)="handleChildEvent($event)"></app-qld-profile-completion>
      }
      }
    </div>
    <!-- Bookings content here -->
    <!-- Bookings content here -->

    <div class="tab-pane fade" id="bookings" role="tabpanel" aria-labelledby="bookings-tab">
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <div class="d-flex align-items-center">
              <h1 class="user-title fs-18">Turn bookings on or off</h1>

              @if(using_cc_to_B) {
              <span class="user-title bookings-tag">Bookings on</span>
              } @else {
              <span class="user-title bookings-tag-off">Bookings off</span>
              }
            </div>
            <!-- <svg (click)="openBookingsOnboardingModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg> -->
          </div>
          <div class="col-md-12 col-lg-12 mt-15">
            <div class="col-md-12 col-sm-12">
              <p class="txt-regular fs-16">
                Toggle on to be available for casual bookings. Toggle off to
                hide your profile and stop new booking requests.
              </p>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="job__alerts switch-green d-flex mt-10">
                <div class="mr-10">
                  <div class="form-check form-switch mt-4 p-0">
                    <input type="checkbox"
                      [disabled]="is_qld_teacher && (profileData?.qld_data?.role_type == 'DRT' || profileData?.qld_data?.role_type == 'LRT')"
                      role="switch" id="availability-switch-1"
                      class="form-check-input delay-send form__switch_cc ml-0 c-p" name="availabilitySwitch1"
                      name="turnOnTeacherPortfolio" [(ngModel)]="using_cc_to_B" [checked]="using_cc_to_B"
                      (change)="onBookingsChange($event)" />
                  </div>
                </div>
                <p class="txt-regular">
                  When your availability is on, your profile is visible to
                  schools. Schools can find and book you, you can also apply for job opportunities through ClassCover
                  Jobs and you also have access to ClassCover’s online library of professional development
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="skills" role="tabpanel" aria-labelledby="skills-tab">
      <!-- Skills and Work experience content here -->
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Skills</h1>
            <svg (click)="openSkillsModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21" fill="#3A0CA3"
              class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>

          </div>

          <div class="col-md-12 col-lg-12 mt-15">
            <h4 class="text-regular-medium fs-16">Teaching levels</h4>
            <div class="col-md-12" *ngIf="profileData?.meta.experiance_tree">
              <ul class="custom-li-tag custom-li-tag d-flex  flex-wrap mr-10">
                @if(profileData?.meta.experiance_tree.length > 0){
                <li *ngFor="let levels of profileData?.meta.experiance_tree">
                  <span class="levels bg-tags">{{ levels }}</span>
                </li>
                } @else{
                <li class="txt-regular tags mt-5">No levels found</li>
                }
              </ul>
            </div>
            <div class="col-md-12" *ngIf="!profileData?.meta.experiance_tree">
              <p class="txt-regular tags mt-5">No levels found</p>
            </div>
          </div>
          <div class="col-md-12 col-lg-12 mt-15">
            <h4 class="text-regular-medium fs-16">Subjects</h4>
            <div class="col-md-12" *ngIf="profileData?.meta.tags">
              <ul class="custom-li-tag d-flex  flex-wrap mr-10">
                @if(profileData?.meta.tags.length > 0){
                <li class="" *ngFor="let tag of profileData?.meta.tags">
                  <span class="qualified-in bg-tags mr-10">{{ tag }}</span>
                </li>
                }@else{
                <li class="txt-regular tags mt-5">No Subjects found</li>
                }
              </ul>
            </div>
            <div class="col-md-12" *ngIf="!profileData?.meta.tags">
              <p class="txt-regular tags mt-5">No Subjects found</p>
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <h4 class="text-regular-medium fs-16 mt-15">Employment summary</h4>
            <div class="" *ngIf="profileData?.meta.experience_description">
              <p class="txt-regular mt-5" *ngIf="profileData?.meta.experience_description.length > 0">
                {{ profileData?.meta.experience_description }}
              </p>
              <p class="txt-regular mt-5" *ngIf="profileData?.meta.experience_description.length == 0">
                No employment summary found
              </p>
            </div>
            <div class="" *ngIf="!profileData?.meta.experience_description">
              <p class="txt-regular mt-5">No employment summary found</p>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Work experience</h1>
            <!-- <svg (click)="openWorkExperienceModal('')" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg> -->
            <svg (click)="openWorkExperienceModal('')" class="c-p" xmlns="http://www.w3.org/2000/svg" width="21"
              height="21" fill="#3A0CA3" stroke="#3A0CA3" class="bi bi-plus-lg" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
            </svg>
          </div>

          <div class="col-md-12 col-lg-12 mt-15">
            <div class="" *ngIf="profileData?.work_experience">
              <div *ngIf="profileData?.work_experience?.work_experience?.length > 0">
                @for (work_experience of
                profileData?.work_experience?.work_experience; track
                work_experience; let i = $index){
                <div class="mt-15">
                  <div class="d-flex align-items-center s_between">
                    <p class="text-regular-medium fs-16">
                      {{ work_experience.job_title }}
                    </p>
                    <!-- <svg (click)="openWorkExperienceModal(work_experience)" xmlns="http://www.w3.org/2000/svg"
                      width="16" height="21" fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                      <path
                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                    </svg> -->
                    <div class="d-flex align-items-center">
                      <svg (click)="openWorkExperienceModal(work_experience)" xmlns="http://www.w3.org/2000/svg"
                        width="16" height="21" fill="#3A0CA3" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                        <path
                          d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#3A0CA3" stroke="#3A0CA3" width="25" height="25"
                        (click)="removeRow('remove_workexperience', i)" class="bi bi-x-circle ml-10 c-p"
                        viewBox="0 0 16 22">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path
                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                      </svg>
                    </div>
                  </div>
                  <p class="txt-regular mt-5">
                    {{ work_experience.school_name }}
                  </p>
                  <p class="txt-regular mt-5">
                    {{ work_experience.from_date }}
                    -
                    {{ work_experience.to_date }}
                  </p>
                  <p class="txt-regular mt-5">
                    {{ work_experience.experience_summary }}
                  </p>
                </div>
                <hr>

                @if(i
                < profileData?.work_experience?.length - 1) { <hr />
                } }
              </div>
              <div>
                <p class="txt-regular mt-5" *ngIf="profileData?.work_experience?.length == 0">
                  No experience found
                </p>
              </div>
            </div>
            <div class="" *ngIf="!profileData?.work_experience">
              <p class="txt-regular mt-5">No experience found</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="qualification" role="tabpanel" aria-labelledby="qualification-tab">
      <!-- Qualification and Documents content here -->
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Qualifications</h1>
            <!-- <svg (click)="openQualificationsModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg> -->
            <svg (click)="openQualificationsModal()" class="c-p" xmlns="http://www.w3.org/2000/svg" width="21"
              height="21" fill="#3A0CA3" stroke="#3A0CA3" class="bi bi-plus-lg" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
            </svg>
          </div>
          <div class="col-md-12 col-lg-12 mt-25" *ngIf="profileData?.meta?.qualifications_v2">
            @for (item of profileData?.meta?.qualifications_v2; track item; let
            i = $index){
            <div class="d-flex align-items-center s_between">
              <h4 class="text-regular-medium fs-16">{{ item.type }}</h4>
              <!-- <svg (click)="openQualificationsModal(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
                fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
              </svg> -->
              <div class="d-flex align-items-center">
                <svg (click)="openQualificationsModal(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
                  fill="#3A0CA3" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                  <path
                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" fill="#3A0CA3" stroke="#3A0CA3" width="25" height="25"
                  (click)="removeRow('remove_qualification', i)" class="bi bi-x-circle ml-10 c-p" viewBox="0 0 16 22">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              </div>
            </div>


            <p class="txt-regular">{{ item.institution }}</p>
            @if(item.file ){
            <a href="{{ item.file }}" target="_self" class="txt-regular a-link underline">View - {{ item.type }}</a>
            }
            @if(i
            < profileData?.meta?.qualifications_v2.length - 1) { <hr />
            } }
            <div class="col-md-12" *ngIf="!profileData?.meta?.qualifications_v2">
              <p class="txt-regular tags mt-5">No Qualifications found</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">Additional documents</h1>
            <!-- <svg (click)="openAdditionalDocumentsModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg> -->
            <svg (click)="openAdditionalDocumentsModal()" class="c-p" xmlns="http://www.w3.org/2000/svg" width="21"
              height="21" fill="#3A0CA3" stroke="#3A0CA3" class="bi bi-plus-lg" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
            </svg>
          </div>
          <div class="col-md-12 col-lg-12 mt-25" *ngIf="profileData?.meta?.attachment_files">
            @for (item of profileData?.meta?.attachment_files; track item; let i
            = $index){
            <div class="d-flex align-items-center s_between">
              <h4 class="text-regular-medium fs-16">{{ item.name }}</h4>
              <!-- <svg (click)="openAdditionalDocumentsModal(item)" xmlns="http://www.w3.org/2000/svg" width="16"
                height="21" fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
              </svg> -->
              <div class="d-flex align-items-center">
                <svg (click)="openAdditionalDocumentsModal(item)" xmlns="http://www.w3.org/2000/svg" width="16"
                  height="21" fill="#3A0CA3" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                  <path
                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
                <svg (click)="removeRow('remove_attachments', i)" xmlns="http://www.w3.org/2000/svg" fill="#3A0CA3"
                  stroke="#3A0CA3" width="25" height="25" class="bi bi-x-circle ml-10 c-p" viewBox="0 0 16 22">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              </div>
            </div>
            <p class="txt-regular">{{ item.description }}</p>
            @if(item.name){
            <a href="{{ item.file }}" target="_self" class="txt-regular a-link underline">View - {{ item.name }}</a>
            }@else {
            <a href="{{ item.file }}" target="_self" class="txt-regular a-link underline">View - Document</a> }
            @if(i
            < profileData?.meta?.attachment_files.length - 1) { <hr />
            } }
            <div class="col-md-12" *ngIf="!profileData?.meta?.attachment_files">
              <p class="txt-regular tags mt-5">No Additional documents found</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="references" role="tabpanel" aria-labelledby="references-tab">
      <!-- References content here -->
      <div class="card mt-15 px-20">
        <div class="row">
          <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
            <h1 class="user-title fs-18">References</h1>
            <!-- <svg (click)="openReferencesModal()" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
              fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
              <path
                d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg> -->
            <svg (click)="openReferencesModal()" class="c-p" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
              fill="#3A0CA3" stroke="#3A0CA3" class="bi bi-plus-lg" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
            </svg>
          </div>
          @if(profileData?.meta?.references &&
          profileData?.meta?.references.length>0) {
          <div class="col-md-12 col-lg-12 mt-25">
            @for (item of profileData?.meta?.references; track item; let i =
            $index){
            <div class="d-flex align-items-center s_between">
              <h4 class="text-regular-medium fs-16">{{ item.name }}</h4>
              <!-- <svg (click)="openReferencesModal(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
                fill="currentColor" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                <path
                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
              </svg> -->
              <div class="d-flex align-items-center">
                <svg (click)="openReferencesModal(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="21"
                  fill="#3A0CA3" class="bi bi-pencil-fill c-p" viewBox="0 0 16 22">
                  <path
                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
                <svg (click)="removeRow('remove_references', i)" xmlns="http://www.w3.org/2000/svg" fill="#3A0CA3"
                  stroke="#3A0CA3" width="25" height="25" class="bi bi-x-circle ml-10 c-p" viewBox="0 0 16 22">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              </div>
            </div>
            <p class="txt-regular">
              {{ item?.position }}
              <span *ngIf="item?.position && item?.org" class="divider-right ml-3 mr-5"> </span>
              <span>
                {{ item?.org }}
              </span>
            </p>
            <p class="txt-regular mt-5">
              <svg *ngIf="item?.phone" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                stroke-width="1" class="bi bi-telephone" viewBox="0 0 15 19">
                <path
                  d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
              </svg>
              {{ item?.phone }}
              <span *ngIf="item?.phone && item?.email" class="divider-right ml-3 mr-5"> </span>
              <span>
                <svg *ngIf="item?.email" xmlns="http://www.w3.org/2000/svg" width="14" height="20" fill="currentColor"
                  class="bi bi-person" viewBox="0 0 15 20" stroke-width="1">
                  <path
                    d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                </svg>
                {{ item?.email }}
              </span>
            </p>
            @if(i
            < profileData?.meta?.references.length - 1) { <hr />
            } }
            <div class="col-md-12" *ngIf="!profileData?.meta?.references">
              <p class="txt-regular tags mt-5">No references found</p>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="availability" role="tabpanel" aria-labelledby="availability-tab">
      <div class="card px-15">
        <!-- <h1 class="user-title fs-18">Availability to work</h1> -->

        <div class="row mb-10 align-items-center">
          <div class="col-12">
            <app-quick-availability-update (availabilityUpdated)="refreshPage()"
              [stats]="this.availability_healthy"></app-quick-availability-update>
          </div>

        </div>
        <hr class="mt-15 mb-15" />
        <!-- Availability to work content here -->
        <app-inline-calendar from="FNT" [availability]="availability">
        </app-inline-calendar>
      </div>
    </div>
  </div>

  <!-- Edit Profile modal -->
  <ng-template #editProfileModal>
    <form [formGroup]="editPersonalInformationForm">
      <div class="modal-header">
        <h5 class="modal-title">Edit Profile</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex align-items-center">
              <div>
                <img alt="" [src]="
                  profileData?.meta?.profile_image == null ||
                  profileData?.meta?.profile_image == ''
                    ? '../../../../assets/images/pro_avatar.png'
                    : profileData?.meta?.profile_image
                " class="profile-avatar" />
              </div>
              <div class="ml-20">
                <label class="form-label">Upload a profile picture</label>
                <input type="file" formControlName="teacher_image" class="form-control"
                  (change)="fileChangeEvent($event)" alt="school logo" />
              </div>
            </div>
            @if (this.imageChangedEvent?.target?.files?.length > 0) {
            <div class="col-6 col-md-4 col-lg-4">
              <div class="cropper-container">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                  [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="3 / 3" format="png"
                  [style.display]="showCropper ? null : 'none'" (imageCropped)="imageCropped($event)"
                  (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)"
                  (loadImageFailed)="loadImageFailed()">
                </image-cropper>
              </div>
            </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 mt-15">
            <label class="form-label">First name <span class="star-red">*</span></label>
            <input onlyAlphabetWithSpace formControlName="firstname" placeholder="Type here" type="text"
              class="form-control" />
          </div>
          <div class="col-lg-6 mt-15">
            <label class="form-label">Last name <span class="star-red">*</span></label>
            <input onlyAlphabetWithSpace formControlName="lastname" placeholder="Type here" type="text"
              class="form-control" />
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-lg-6 mt-15">
          <label class="form-label">Previous Last name</label>
          <input formControlName="previous_lastname" placeholder="Type here" type="text" class="form-control" />
        </div> -->
          <div class="col-lg-12 mt-15">
            <label class="form-label">Gender <span class="text-danger">*</span></label>
            <select formControlName="gender" class="form-select">
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
              <option value="Prefered not to say">I'd rather not say</option>
            </select>
          </div>
        </div>
        <h1 class="text-regular-medium fs-18 mt-15">Address</h1>
        <div class="row">
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Country <span class="text-danger">*</span></label>
            <select formControlName="country" (change)="onCountryChange()" class="form-select">
              @for(item of countries; track item) {
              <option [value]="item.value">{{ item.title }}</option>
              }
            </select>
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">State <span class="text-danger">*</span></label>
            <select formControlName="address_state" class="form-select">
              @for(item of availableStates; track item) {
              <option [value]="item.value">{{ item.title }}</option>
              }
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Street number <span class="text-danger">*</span></label>
            <input formControlName="address_streetNumber" type="text" placeholder="Enter street number"
              class="form-control" />
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Street name <span class="text-danger">*</span></label>
            <input onlyAlphabetWithSpace formControlName="address_streetName" type="text"
              placeholder="Enter street name" class="form-control" />
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">City or Suburb <span class="text-danger">*</span></label>
            <input onlyAlphabetWithSpace formControlName="address_city" type="text" placeholder="Enter city or suburb"
              class="form-control" />
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Postal code <span class="text-danger">*</span></label>
            <input onlyNumbers formControlName="address_postalcode" type="text" placeholder="Enter postal code"
              class="form-control" />
          </div>
        </div>
        <h1 class="text-regular-medium fs-18 mt-15">Contact</h1>
        <div class="row">
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Mobile number <span class="text-danger">*</span></label>
            <input onlyMobileNumber formControlName="mobilephonenumber" type="text" placeholder="Enter mobile number"
              class="form-control" />
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Email <span class="text-danger">*</span></label>
            <input readonly formControlName="email" type="text" placeholder="Enter email" class="form-control" />
          </div>
        </div>
        @if(profileData?.qld_data){
        <h1 class="text-regular-medium fs-18 mt-15">Emergency Contacts</h1>
        <div class="row">
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Emergency contact name 1</label>
            <input onlyAlphabetWithSpace formControlName="emergency_contact_name1" type="text" placeholder="Enter name"
              class="form-control" />
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Emergency contact phone 1</label>
            <input onlyMobileNumber formControlName="emergency_contact_phone1" type="text"
              placeholder="Enter phone number" class="form-control" />
            <div *ngIf="editPersonalInformationForm.get('emergency_contact_phone1')?.errors?.['pattern']"
              class="invalid-feedback-qld">
              Please enter a valid phone number
            </div>
          </div>
          <div class="col-lg-12 col-md-6 mt-15">
            <label class="form-label">Relationship</label>
            <input onlyAlphabetWithSpace formControlName="emergency_contact_relation1" type="text"
              placeholder="e.g., Parent, Spouse" class="form-control" />
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Emergency contact name 2</label>
            <input onlyAlphabetWithSpace formControlName="emergency_contact_name2" type="text" placeholder="Enter name"
              class="form-control" />
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Emergency contact phone 2</label>
            <input onlyMobileNumber formControlName="emergency_contact_phone2" type="text"
              placeholder="Enter phone number" class="form-control" />
            <div *ngIf="editPersonalInformationForm.get('emergency_contact_phone2')?.errors?.['pattern']"
              class="invalid-feedback-qld">
              Please enter a valid phone number
            </div>
          </div>
          <div class="col-lg-12 col-md-6 mt-15">
            <label class="form-label">Relationship</label>
            <input onlyAlphabetWithSpace formControlName="emergency_contact_relation2" type="text"
              placeholder="e.g., Parent, Spouse" class="form-control" />
          </div>
        </div>
        }
        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('profileDetails')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #editStatusModal>
    <form [formGroup]="editStatusForm">
      <div class="modal-header">
        <h5 class="modal-title">Status</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 mt-15">
            <label class="txt-regular grey-2">Update your status to display to new and existing schools</label>
            <textarea formControlName="status" class="form-control mt-10" placeholder="Type here" rows="7"
              maxlength="140" (input)="onStatusInput()"></textarea>
            <div class="txt-regular fs-14 mt-5">
              {{ editStatusForm.get("status")?.value?.length || 0 }}/140
            </div>
            <p class="txt-regular fs-16 mt-20">Examples</p>
            <ul class="mt-10 mb-0 txt-regular fs-16">
              <li class="mt-10">Willing to travel up to 30 kms</li>
              <li class="mt-10">Block work until term 2</li>
              <li class="mt-10">On maternity leave</li>
              <li class="mt-10">Looking for full time classroom work</li>
              <li class="mt-10">Special education trained</li>
            </ul>
          </div>
        </div>
        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('teacherStatus')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #editAccreditationModal>
    <form [formGroup]="editAccreditationForm">
      <div class="modal-header">
        <h5 class="modal-title">Accreditation</h5>
        <button type="button" class="btn-close" (click)="closeAccreditationModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Accreditation name <span class="text-danger">*</span></label>
            <input formControlName="accreditation_name" type="text" placeholder="Enter accreditation name"
              class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Accreditation number <span class="text-danger">*</span></label>
            <input formControlName="accreditation_id" type="text" placeholder="Enter accreditation number"
              class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Accreditation expiry <span class="text-danger">*</span></label>
            <input formControlName="expiry_date" type="text" placeholder="Select date" class="form-control" bsDatepicker
              [bsConfig]="{
              dateInputFormat: 'DD/MM/YYYY',
              containerClass: 'theme-red',
              showWeekNumbers: false,
              adaptivePosition: true
            }" [daysDisabled]="[6, 0]" />
          </div>
        </div>
        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('accreditation')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #rightsToWorkModal>
    <form [formGroup]="rightsToWorkForm">
      <div class="modal-header">
        <h5 class="modal-title">Right to work in Australia or New Zealand</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label">Right to work in Australia
              <span class="text-danger">*</span></label>
            <select formControlName="right_to_work" class="form-select">
              <option value="">Please choose</option>
              <option value="I am an Australian or New Zealand Citizen">
                I am an Australian or New Zealand Citizen
              </option>
              <option value="Permanent Resident">Permanent resident</option>
              <option value="Temporary work visa">Temporary work visa</option>
              <option value="NZ citizenship with special category visa">
                NZ citizenship with special category visa
              </option>
              <option value="None of the above">None of the above</option>
            </select>
          </div>
          <div class="col-lg-6 col-md-6 mt-15">
            <label class="form-label" for="work_start_date">Working start date </label>
            <div class="d-flex name-input">
              <input ngbDatepicker #d="ngbDatepicker" formControlName="work_start_date" class="form-control white-bg"
                id="work_start_date" readonly aria-label="Date input, format dd/mm/yyyy"
                aria-describedby="pending-date-help" autocomplete="off" (click)="d.open()"
                (keydown)="onDateInputKeyDown($event, d)" [minDate]="{ year: 1950, month: 1, day: 1 }"
                [maxDate]="{ year: 2026, month: 12, day: 31 }" />
              <span id="pending-date-help" class="sr-only">
                Enter date in format dd/mm/yyyy. Use arrow keys to navigate calendar. Press Enter to open/close
                picker.
              </span>
              <button class="input-group-text" role="button" (click)="clearSinglePicker()"><i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>

        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('rightsToWork')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #skillsModal>
    <form [formGroup]="skillsForm">
      <div class="modal-header">
        <h5 class="modal-title">Skills</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Teaching levels I am qualified to teach
              <span class="text-danger">*</span></label>
            <ng-container *ngIf="profileData?.consumer_type?.parent_type_id === 1; else combinedTeachingLevels">
              <!-- Separate parent/child dropdowns -->
              <ng-select [items]="parentLevels" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedParents"
                (change)="onParentChange($event)" [multiple]="true" [bindLabel]="'label'" [bindValue]="'value'"
                [dropdownPosition]="'bottom'" [searchable]="false" [clearable]="false"
                aria-labelledby="teaching-level-category-label" placeholder="Select category">
              </ng-select>
              <div *ngIf="selectedParents.length === 0 && skillsForm.touched" aria-live="assertive"
                class="text-danger txt-regular fs-12">
                Please select at least one teaching level.
              </div>
              <div class="mt-2" *ngIf="selectedParents.length > 0">
                <label class="form-label mt-15" id="teaching-level-detail-label">
                  What years do you teach? <span class="text-danger">*</span>
                </label>
                <ng-select [items]="childLevels" [(ngModel)]="selectedChildren" [multiple]="true"
                  [dropdownPosition]="'bottom'" [ngModelOptions]="{standalone: true}" [searchable]="true"
                  (change)="onChildChange($event)" [clearable]="true" aria-labelledby="teaching-level-detail-label"
                  placeholder="Search by level">
                </ng-select>
                <div *ngIf="selectedChildren.length === 0 && skillsForm.touched" aria-live="assertive"
                  class="text-danger txt-regular fs-12">
                  Please select at least one year level.
                </div>
              </div>
            </ng-container>
            <ng-template #combinedTeachingLevels>
              <!-- Combined dropdown for other roles -->
              <ng-select [dropdownPosition]="'bottom'" formControlName="experiance_tree" [items]="experiance_tree"
                [multiple]="true" bindLabel="title" bindValue="value" placeholder="Search by level">
              </ng-select>
            </ng-template>
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Subjects I am qualified to teach (Limit 10)
              <span *ngIf="isTeacherRole" class="text-danger">*</span>
            </label>
            <ng-select [dropdownPosition]="'bottom'" formControlName="tags" [items]="subjectFilter" [multiple]="true"
              bindLabel="title" bindValue="value" [maxSelectedItems]="10" placeholder="Search by subject">
            </ng-select>
            <div
              *ngIf="isTeacherRole && skillsForm.get('tags')?.touched && (!skillsForm.get('tags')?.value || skillsForm.get('tags')?.value.length === 0)"
              aria-live="assertive" class="text-danger txt-regular fs-12">
              Please select subjects.
            </div>
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Video Introduction</label>
            <input formControlName="video_cv" type="text" placeholder="Enter video introduction link"
              class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Short bio</label>
            <textarea formControlName="experience_description" type="text" placeholder="Enter short bio"
              class="form-control" maxlength="500"></textarea>
            <div class="txt-regular fs-12 mt-5">
              {{
              skillsForm.get("experience_description")?.value?.length || 0
              }}/500
            </div>
          </div>
        </div>

        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('skills')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #workExperienceModal>
    <form [formGroup]="workExperienceForm">
      <div class="modal-header">
        <h5 class="modal-title">Work Experience</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Job title <span class="text-danger">*</span></label>
            <input formControlName="job_title" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Company/School <span class="text-danger">*</span></label>
            <input formControlName="school_name" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Start date <span class="text-danger">*</span></label>
            <input formControlName="from_date" type="text" placeholder="Select date" class="form-control" bsDatepicker
              [bsConfig]="{
              dateInputFormat: 'DD/MM/YYYY',
              containerClass: 'theme-red',
              showWeekNumbers: false,
              adaptivePosition: true
            }" [daysDisabled]="[6, 0]" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">End date <span class="text-danger">*</span></label>
            <input formControlName="to_date" type="text" placeholder="Select date" class="form-control" bsDatepicker
              [bsConfig]="{
              dateInputFormat: 'DD/MM/YYYY',
              containerClass: 'theme-red',
              showWeekNumbers: false,
              adaptivePosition: true
            }" [daysDisabled]="[6, 0]" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">About your work experience <span class="text-danger">*</span></label>
            <textarea formControlName="experience_summary" type="text" placeholder="Type here" class="form-control"
              maxlength="300"></textarea>
            <div class="txt-regular fs-12 mt-5">
              {{
              workExperienceForm.get("experience_summary")?.value?.length || 0
              }}/300
            </div>
          </div>
        </div>

        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('workExperience')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #qualificationsModal>
    <form [formGroup]="qualificationsForm">
      <div class="modal-header">
        <h5 class="modal-title">Add your qualification</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Type <span class="text-danger">*</span></label>
            <select formControlName="type" class="form-select">
              <option *ngFor="let item of qualification_choices; let i = index" [value]="i === 0 ? '' : item">{{ item
                }}
              </option>
            </select>
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Name</label>
            <input formControlName="title" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Institution</label>
            <input formControlName="institution" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-md-12 col-lg-12 col-sm-12 add-image mt-20">
            <label class="filelabel parent-ele" id="FileInput_label" for="FileInput">
              <p class="b clr-grey mt-5">Attachment</p>
              <p class="clr-grey mt-5">Drag and drop a file</p>
              <p class="text-regular mt-5">Or</p>
              <div class="d-flex justify-content-center mt-5">
                <a class="d-flex file-upload-text align-items-center">
                  <i class="bi bi-paperclip mr-5"></i> Upload file
                </a>
              </div>
              <p class="text-regular mt-5 file_name" *ngIf="fileName">
                <!-- <span *ngIf="!fileName" class="clr-red ">No file
                                        choosen</span> -->
                <span class="file_attached">{{ fileName }}</span>
                <button class="ml-4" role="button" (click)="removeFile($event); $event.stopPropagation()">
                  <i class="bi bi-x-lg"></i>
                </button>
              </p>

              <input aria-label="Qualification Attachment" aria-labelledby="FileInput_label" role="textbox"
                class="FileUpload1 form-control child-ele" id="FileInput" (change)="onFileSelected($event)"
                name="QualificationAttachment" type="file" />
            </label>
          </div>
        </div>

        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('qualifications')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #additionalDocumentsModal>
    <form [formGroup]="additionalDocumentsForm">
      <div class="modal-header">
        <h5 class="modal-title">Additional documents</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Name</label>
            <input formControlName="name" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Description</label>
            <input formControlName="description" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-md-12 col-lg-12 col-sm-12 add-image mt-20">
            <label class="filelabel parent-ele" id="FileInput_label" for="FileInput">
              <p class="b clr-grey mt-5">Attachment <span class="text-danger">*</span></p>
              <p class="clr-grey mt-5">Drag and drop a file</p>
              <p class="text-regular mt-5">Or</p>
              <div class="d-flex justify-content-center mt-5">
                <a class="d-flex file-upload-text align-items-center">
                  <i class="bi bi-paperclip mr-5"></i> Upload file
                </a>
              </div>
              <p class="text-regular mt-5 file_name" *ngIf="addFileName || existingFileName">
                <span class="file_attached">{{ addFileName || existingFileName }}</span>
                <button *ngIf="existingFileName == ''" class="ml-4" role="button"
                  (click)="removeAdditionalFile($event); $event.stopPropagation()">
                  <i class="bi bi-x-lg"></i>
                </button>
              </p>
              <input aria-label="Additional Document Attachment" aria-labelledby="FileInput_label" role="textbox"
                class="FileUpload1 form-control child-ele" id="FileInput" (change)="onFileSelectedAdditional($event)"
                name="additional_document_attachment" type="file" />
              <div *ngIf="showAttachmentError" class="clr-red">Attachment is required</div>
            </label>
          </div>
        </div>

        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('additionalDocuments')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #referenceModal>
    <form [formGroup]="referenceForm">
      <div class="modal-header">
        <h5 class="modal-title">Add a reference</h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Full name <span class="text-danger">*</span></label>
            <input formControlName="name" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Email <span class="text-danger">*</span></label>
            <input formControlName="email" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Phone number</label>
            <input formControlName="phone" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Position</label>
            <input formControlName="position" type="text" placeholder="Type here" class="form-control" />
          </div>
          <div class="col-lg-12 col-md-12 mt-15">
            <label class="form-label">Organisation</label>
            <input formControlName="org" type="text" placeholder="Type here" class="form-control" />
          </div>
        </div>

        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('reference')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #roleTypeModal>
    <form [formGroup]="roleTypeForm">
      <div class="modal-header">
        <h5 class="modal-title">Help us understand who you are</h5>
        <button type="button" class="btn-close" (click)="closeRoleTypeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0">
        <div class="row">
          <div class="col-lg-12 mt-15 I_am">
            <!-- Main radio group -->
            <div *ngIf="showMainRoleType">
              <!-- @if(teachLocalData?.properties?.is_qld_teacher){
              <div *ngFor="let item of consumer_type_parentTag; let i = index">
                <div *ngIf="i === 0" class="form-check mt-2">
                  <input class="form-check-input mt-4" type="radio" name="role_type" id="{{ item.parent_id }}"
                    value="{{ item.parent_id }}" formControlName="role_type"
                    (click)="onRoleTypeChange(item.tag, item.parent_id)" />
                  <label class="form-check-label" for="{{ item.parent_id }}">{{
                    item.title
                    }}</label>
                </div>
              </div>
              }@else { -->
              <div *ngFor="let item of consumer_type_parentTag; let i = index">
                <div class="form-check mt-2">
                  <input class="form-check-input mt-4" type="radio" name="role_type" id="{{ item.parent_id }}"
                    value="{{ item.parent_id }}" formControlName="role_type"
                    (click)="onRoleTypeChange(item.tag, item.parent_id)" />
                  <label class="form-check-label" for="{{ item.parent_id }}">{{
                    item.title
                    }}</label>
                </div>
              </div>
              <!-- } -->
            </div>

            <div *ngIf="iAmTeaching" class="mt-3">
              <div class="form-check mt-2">
                <input class="form-check-input mt-4" type="radio" id="i_am_teacher_only" value="i_am_teacher" checked
                  disabled />
                <label class="form-check-label" for="i_am_teacher_only">I am a teacher</label>
              </div>
              <p class="txt-regular mt-10">A little bit more about you...</p>
              <div class="col-lg-12 col-md-12 mt-15">
                <label class="form-label" id="teaching-level-category-label">
                  Teaching levels I am qualified to teach <span class="text-danger">*</span>
                </label>
                <ng-select [items]="parentLevels" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedParents"
                  (change)="onParentChange($event)" [multiple]="true" [bindLabel]="'label'" [bindValue]="'value'"
                  [dropdownPosition]="'bottom'" [searchable]="false" [clearable]="false"
                  aria-labelledby="teaching-level-category-label" placeholder="Select category">
                </ng-select>
                <div
                  *ngIf="isTeacherRole && selectedParents.length === 0 && roleTypeForm.get('experiance_tree')?.touched"
                  aria-live="assertive" class="text-danger txt-regular fs-12">
                  Please select at least one teaching level.
                </div>
              </div>
              <div class="col-lg-12 col-md-12 mt-15" *ngIf="selectedParents.length > 0">
                <label class="form-label" id="teaching-level-detail-label">
                  What years do you teach? <span class="text-danger">*</span>
                </label>
                <ng-select [items]="childLevels" [(ngModel)]="selectedChildren" [multiple]="true"
                  [dropdownPosition]="'bottom'" [ngModelOptions]="{standalone: true}" [searchable]="true"
                  (change)="onChildChange($event)" [clearable]="true" aria-labelledby="teaching-level-detail-label"
                  placeholder="Search by level">
                </ng-select>
                <div
                  *ngIf="isTeacherRole && selectedParents.length > 0 && selectedChildren.length === 0 && roleTypeForm.get('experiance_tree')?.touched"
                  class="text-danger  txt-regular fs-12">
                  Please select at least one year/level.
                </div>
              </div>
              <div class="col-lg-12 col-md-12 mt-15">
                <!-- Hide subject field ONLY if Early Childhood is the ONLY selection -->
                <ng-container
                  *ngIf="!(selectedParents.length === 1 && selectedParents[0] === 'Early Childhood') && (selectedParents.includes('Secondary') || selectedParents.includes('Primary'))">
                  <label class="form-label">Subjects I am qualified to teach (Limit 10)
                    <span class="text-danger" *ngIf="selectedParents.includes('Secondary')">*</span>
                  </label>
                  <ng-select [dropdownPosition]="'bottom'" formControlName="tags" [items]="subjectFilter"
                    [multiple]="true" bindLabel="title" bindValue="value" [maxSelectedItems]="10"
                    placeholder="Search by subject">
                  </ng-select>
                  <!-- Required error for Secondary only -->
                  <div
                    *ngIf="selectedParents.includes('Secondary') && skillsForm.get('tags')?.touched && (!skillsForm.get('tags')?.value || skillsForm.get('tags')?.value.length === 0)"
                    aria-live="assertive" class="text-danger txt-regular fs-12">
                    Please select subjects.
                  </div>
                </ng-container>
              </div>
              <button type="button" class="btn btn-link mt-3 t-dec-none  clr-cc-vilot" (click)="onRoleTypeBack()">
                ← Back
              </button>
            </div>
            <!-- If studying, show only selected and extra input -->
            <div *ngIf="showUniStudentType">
              <div class="form-check mt-2">
                <input class="form-check-input mt-4" type="radio" id="studying_only" value="studying" checked
                  disabled />
                <label class="form-check-label" for="studying_only">I am studying to be a teacher</label>
              </div>
              <div class="mt-3">
                <label class="form-label">Which description fits you best

                  <span class="text-danger">*</span></label>
                <select type="text" class="status_year form-select" data-usertype=" stu_type" name="stu_type"
                  formControlName="stu_type">
                  <option value="">Select here</option>
                  @for(item of consumer_typeStudent; track item) {
                  <option id="nsw_subType_{{ item.sub_type_id }}" value="{{ item.sub_type_id }}">
                    {{ item.title }}
                  </option>
                  }
                </select>
              </div>
              <div class="mt-3">
                <label class="form-label">Name of the University

                  <span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="university" placeholder="University name" />
              </div>
              <div class="mt-3">
                <label class="form-label">
                  Expected year of completion
                  <span class="text-danger">*</span>
                </label>
                <select class="form-select" formControlName="passed_year">
                  <option value="">Year of completion</option>
                  @for( year of getYearsList(); track year) {
                  <option [value]="year">{{ year }}</option>
                  }
                </select>
              </div>
              <button type="button" class="btn btn-link mt-3 t-dec-none  clr-cc-vilot" (click)="onRoleTypeBack()">
                ← Back
              </button>
            </div>

            <!-- If not a teacher, show only selected and 10 radio options -->
            <div *ngIf="showNonTeacherType">
              <div class="form-check mt-2">
                <input class="form-check-input mt-4" type="radio" id="not_teacher_only" value="not_teacher" checked
                  disabled />
                <label class="form-check-label" for="not_teacher_only">I am not a teacher</label>
              </div>
              <div class="mt-3">
                <p class="txt-regular fs-16">
                  I’m <span class="text-danger">*</span>
                </p>
                @for(item of consumer_typeNonTeacher; track item) {
                <div class="form-check mt-2">
                  <input class="form-check-input mt-4" type="radio" id="{{ item.sub_type_id }}" name="not_teacher_role"
                    value="{{ item.sub_type_id }}" formControlName="not_teacher_role" />
                  <label class="form-check-label" for="{{ item.sub_type_id }}">
                    {{ item.title }}
                    <small class="ms-2 text-muted">{{ item.tag }}</small>
                  </label>
                </div>
                }
                <button type="button" class="btn btn-link mt-3 t-dec-none clr-cc-vilot" (click)="onRoleTypeBack()">
                  ← Back
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr class="mb-10 mt-10" />
        <div class="modal-footer pt-0">
          <button type="button" class="btn cc_p_btn fs_13" (click)="saveProfile('roleType')">
            Save
          </button>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template #bceQuestionsModal>
    <form [formGroup]="bceQuestionsForm">
      <div class="modal-header">
        <h5 class="modal-title">
          Brisbane Catholic Education Mandatory Questions
        </h5>
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-0 bce_questions">
        <div class="mb-10">
          <label class="form-label">
            Are you planning to work in Brisbane Catholic Education Schools?
            <span class="text-danger">*</span>
          </label>
          <br />
          <div class="form-check form-check-inline">
            <input class="form-check-input mt-4" type="radio" id="bce_modal_yes" value="Y"
              formControlName="bce_work_status" [checked]="bce_work_status === 'Y'"
              (change)="openBceModal('Y', 'modal')" />
            <label class="form-check-label" for="bce_modal_yes">Yes</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input mt-4" type="radio" id="bce_modal_no" value="N"
              formControlName="bce_work_status" [checked]="bce_work_status === 'N'"
              (change)="openBceModal('N', 'modal')" />
            <label class="form-check-label" for="bce_modal_no">No</label>
          </div>
        </div>
        <div *ngIf="bceQuestionsForm.value.bce_work_status === 'Y'">
          <!-- Stepper UI -->
          <!-- Stepper UI for BCE Modal -->
          <div class="bce-stepper d-flex align-items-center justify-content-center mb-5">
            <!-- Step 1 -->
            <div class="step-circle" [ngClass]="{ active: step === 1, completed: step > 1 }"></div>
            <div class="step-line" [ngClass]="{ active: step > 1 }"></div>
            <!-- Step 2 -->
            <div class="step-circle" [ngClass]="{ active: step === 2, completed: step > 2 }"></div>
            <div class="step-line" [ngClass]="{ active: step > 2 }"></div>
            <!-- Step 3 -->
            <div class="step-circle" [ngClass]="{ active: step === 3 }"></div>
          </div>
          <div class="bce-step-labels d-flex justify-content-between mb-15 px-2">
            <span class="step-label txt-regular" [ngClass]="{ active: step === 1, completed: step > 1 }">Mandatory
              Questions</span>
            <span class="step-label txt-regular" [ngClass]="{ active: step === 2, completed: step > 2 }">Safeguarding
              Questions</span>
            <span class="step-label txt-regular" [ngClass]="{ active: step === 3 }">Multiple Choice Questions</span>
          </div>
          <!-- 
        <div class="stepper mb-4 d-flex align-items-center">
          <div [class.completed]="step >= 1" class="step">
            <span>1</span>
            <span class="ms-2">Mandatory Questions</span>
            <span *ngIf="step > 1" class="tick">&#10003;</span>
          </div>
          <div class="step-divider"></div>
          <div [class.completed]="step >= 2" class="step">
            <span>2</span>
            <span class="ms-2">Safeguarding Questions</span>
            <span *ngIf="step > 2" class="tick">&#10003;</span>
          </div>
          <div class="step-divider"></div>
          <div [class.completed]="step === 3" class="step">
            <span>3</span>
            <span class="ms-2">Multiple Choice Questions</span>
          </div>
        </div> -->

          <!-- Step 1: Mandatory Questions -->
          <div *ngIf="step === 1">
            <div class="mb-20">
              <label for="locationPreference" id="locationPreferenceLabel" class="form-label">
                Location preference
                <span class="text-danger" aria-hidden="true">*</span>
              </label>

              <ng-select id="locationPreference" [dropdownPosition]="'bottom'" formControlName="prefered_location"
                [items]="location_preferences" [multiple]="true" bindLabel="title" bindValue="value"
                placeholder="Search by Location" aria-labelledby="locationPreferenceLabel" aria-required="true">
              </ng-select>
            </div>

            <!-- Inside Step 1: Mandatory Questions -->
            <div class="mb-20">
              <label class="form-label">QCT/Blue card number <span class="text-danger">*</span></label>
              <br />
              <div class="form-check form-check-inline">
                <input appFocus type="radio" formControlName="card_type" value="blueCard" class="form-check-input mt-4"
                  id="bce_modal_blue_card" [checked]="
                  profileData?.bce_data?.meta?.card_type === 'blueCard'
                " (change)="onCardTypeChange('blueCard')" aria-describedby="blueCardHelp" />
                <label id="blueCardHelp" class="form-check-label" for="bce_modal_blue_card">Blue Card Number</label>
              </div>
              <div class="form-check form-check-inline">
                <input appFocus type="radio" formControlName="card_type" value="QCT" class="form-check-input mt-4"
                  id="bce_modal_qc" [checked]="profileData?.bce_data?.meta?.card_type === 'QCT'"
                  (change)="onCardTypeChange('QCT')" aria-describedby="qcHelp" />
                <label id="qcHelp" class="form-check-label" for="bce_modal_qc">QCT Number</label>
              </div>
            </div>

            <!-- Blue Card Section -->
            <div *ngIf="bceQuestionsForm.value.card_type === 'blueCard'" class="mb-20">
              <div class="mb-3">
                <div class="mb-20">
                  <label class="form-label">Type of blue card <span class="text-danger">*</span></label>
                  <br />
                  <div class="form-check form-check-inline">
                    <input appFocus type="radio" formControlName="blue_card_type" value="Paid"
                      class="form-check-input mt-4" id="bce_modal_blue_card_paid" [checked]="
                  profileData?.bce_data?.meta?.blue_card_type === 'Paid'
                " aria-describedby="blueCardTypePaidHelp" />
                    <label id="blueCardTypePaidHelp" class="form-check-label"
                      for="bce_modal_blue_card_paid">Paid</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input appFocus type="radio" formControlName="blue_card_type" value="Volunteer"
                      class="form-check-input mt-4" id="bce_modal_blue_card_volunteer"
                      [checked]="profileData?.bce_data?.meta?.blue_card_type === 'Volunteer'"
                      aria-describedby="blueCardTypeVolunteerHelp" />
                    <label id="blueCardTypeVolunteerHelp" class="form-check-label"
                      for="bce_modal_blue_card_volunteer">Volunteer</label>
                  </div>
                </div>
                <label for="cardHolderName" id="cardHolderNameLabel" class="form-label">
                  Blue card holder's name (as appears on card)
                  <span class="text-danger" aria-hidden="true">*</span>
                </label>

                <input id="cardHolderName" formControlName="card_holder_name" type="text" placeholder="Type here"
                  class="form-control" required aria-required="true" aria-labelledby="cardHolderNameLabel" />
              </div>

              <label id="blueCardLabel" class="form-label mt-20">
                Blue Card Number <span class="text-danger">*</span>
              </label>
              <div class="d-flex">
                <ng-container *ngFor="let box of blueCardBoxes; let i = index">
                  <input type="text" maxlength="1" class="form-control otp-box" onlyNumbers
                    [formControlName]="'blueCard_' + '[' + i + ']'" required style="width: 40px; margin-right: 5px"
                    (input)="onBlueCardDigitInput($event, i)" [id]="'blueCard_' + '[' + i + ']'" autocomplete="off"
                    [attr.aria-label]="'Blue card digit ' + (i + 1)" inputmode="numeric" />
                </ng-container>
                <span class="divider_bluecard">/</span>
                <input type="text" maxlength="2" class="form-control otp-box" onlyNumbers formControlName="blueCard_[7]"
                  required style="width: 60px" (input)="onBlueCardDigitInput($event, 7)" id="blueCard_[7]"
                  aria-label="Blue card last digit" autocomplete="off" />
              </div>

              <label id="expiryDateLabel" class="form-label mt-20">Expiry date <span
                  class="text-danger">*</span></label>
              <input formControlName="expiry_date" type="text" placeholder="Select date" class="form-control"
                bsDatepicker aria-labelledby="expiryDateLabel" inputmode="numeric" [bsConfig]="{
                dateInputFormat: 'DD/MM/YYYY',
                containerClass: 'theme-red',
                showWeekNumbers: false,
                adaptivePosition: true
              }" [daysDisabled]="[6, 0]" />
            </div>

            <!-- QCT Section -->
            <div *ngIf="bceQuestionsForm.value.card_type === 'QCT'" class="mb-20">
              <label class="form-label">QCT Number <span class="text-danger">*</span></label>
              <div class="d-flex">
                <ng-container *ngFor="let box of qctBoxes; let i = index">
                  <input type="text" maxlength="1" class="form-control otp-box" onlyNumbers
                    [formControlName]="'qct_' + '[' + i + ']'" required style="width: 40px; margin-right: 5px"
                    (input)="onQctDigitInput($event, i)" [id]="'qct_' + '[' + i + ']'" autocomplete="off"
                    [attr.aria-label]="'QCT digit ' + (i + 1)" inputmode="numeric" />
                </ng-container>
              </div>
            </div>

            <div class="mb-20">
              <label class="form-label">Personal email <span class="text-danger">*</span></label>
              <input formControlName="personal_email" type="email" class="form-control" required placeholder="Type here"
                aria-label="Personal email address" />
            </div>
            <div class="mb-20">
              <label class="form-label">Right to work <span class="text-danger">*</span></label>
              <select formControlName="right_to_work" class="form-select" required aria-label="Right to work status">
                <option value="">Select</option>
                @for(item of right_to_work; track item) {
                <option value="{{ item }}">{{ item }}</option>
                }
              </select>
            </div>
            <div>
              <label class="form-label">Upload your CV <span class="text-danger">*</span></label>
              <div class="mb-20 add-image">
                <label class="filelabel parent-ele" id="FileInput_label" for="FileInput">
                  <p class="b clr-grey mt-5">Attachment</p>
                  <p class="clr-grey mt-5">Drag and drop a file</p>
                  <p class="text-regular mt-5">Or</p>
                  <div class="d-flex justify-content-center mt-5">
                    <a class="d-flex file-upload-text align-items-center">
                      <i class="bi bi-paperclip mr-5"></i> Upload file
                    </a>
                  </div>

                  <p class="text-regular mt-5 file_name" *ngIf="bceFileName">
                    <span class="file_attached">{{ bceFileName }}</span>
                    <!-- Only show remove button if file is not from profileData (i.e., user uploaded in this session) -->
                    <button *ngIf="!profileData?.bce_data?.file || bceQuestionsForm.value.file" class="ml-4"
                      role="button" (click)="removeBceFile($event); $event.stopPropagation()">
                      <i class="bi bi-x-lg"></i>
                    </button>
                  </p>

                  <input aria-label="Additional Document Attachment" aria-labelledby="FileInput_label" role="textbox"
                    class="FileUpload1 form-control child-ele" id="FileInput" (change)="onBceFileSelected($event)"
                    name="BceAttachment" type="file" />
                </label>
              </div>
            </div>
            <div class="mb-20">
              <label class="form-label" for="aboutInterest">
                What interests you about working for BCE?
                <span class="text-danger">*</span>
              </label>

              <input id="aboutInterest" formControlName="about_interest" class="form-control" type="text"
                placeholder="Type here" required aria-required="true" />
            </div>

            <div class="mb-20">
              <label class="form-label" id="roleInterestedLabel">
                Role interested in <span class="text-danger">*</span>
              </label>

              <ng-select formControlName="bce_roles" [dropdownPosition]="'bottom'" [items]="roles_interested_in"
                [multiple]="true" bindLabel="title" bindValue="value" placeholder="Search by level"
                aria-labelledby="roleInterestedLabel">
              </ng-select>
            </div>

            <div class="mb-20">
              <label class="form-label" id="interestedRoleLabel">
                Interested in <span class="text-danger">*</span>
              </label>

              <ng-select formControlName="interested_role" [dropdownPosition]="'bottom'" [items]="interested_role"
                [multiple]="true" bindLabel="title" bindValue="value" placeholder="Search by level"
                aria-labelledby="interestedRoleLabel">
              </ng-select>
            </div>
            <div class="modal-footer pt-0">
              <button type="button" class="btn cc_p_btn fs_13" (click)="goToStep(2)">
                Next
              </button>
              <!-- <div class="text-danger mt-2" *ngIf="showBceFormError">
              {{ missingFieldsError }}
            </div>
            <div class="text-danger mt-2" *ngIf="showBceFormError">
              Please fill all mandatory details before proceeding.
            </div> -->
            </div>
          </div>

          <!-- Step 2: Safeguarding Questions -->
          <div *ngIf="step === 2">
            <p class="mb-20 txt-regular">
              The following questions are sensitive, and we ask that you respond
              honestly, they relate to the abuse, exploitation, or neglect of a
              child or vulnerable adult.
            </p>

            <!-- Question 1 -->
            <div class="mb-10">
              <label class="form-label" id="negative_notice_label">
                Have you been issued a negative notice (Blue card)?
              </label><br />

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="negative_notice" value="Yes"
                  [checked]="profileData?.bce_data?.meta?.negative_notice === 'Yes'" class="form-check-input mt-4"
                  id="safeguardingQuestions0" aria-labelledby="negative_notice_label safeguardingQuestions0" />
                <label class="form-check-label" for="safeguardingQuestions0">Yes</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="negative_notice" value="No"
                  [checked]="profileData?.bce_data?.meta?.negative_notice === 'No'" class="form-check-input mt-4"
                  id="safeguardingQuestions_0" aria-labelledby="negative_notice_label safeguardingQuestions_0" />
                <label class="form-check-label" for="safeguardingQuestions_0">No</label>
              </div>
            </div>

            <!-- Question 2 -->
            <div class="mb-10">
              <label class="form-label" id="suspended_registration_label">
                Have you ever had your QCT registration or Blue card suspended?
              </label><br />

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="suspended_registration" value="Yes"
                  [checked]="profileData?.bce_data?.meta?.suspended_registration === 'Yes'"
                  class="form-check-input mt-4" id="safeguardingQuestions1"
                  aria-labelledby="suspended_registration_label safeguardingQuestions1" />
                <label class="form-check-label" for="safeguardingQuestions1">Yes</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="suspended_registration" value="No"
                  [checked]="profileData?.bce_data?.meta?.suspended_registration === 'No'" class="form-check-input mt-4"
                  id="safeguardingQuestions_1" aria-labelledby="suspended_registration_label safeguardingQuestions_1" />
                <label class="form-check-label" for="safeguardingQuestions_1">No</label>
              </div>
            </div>

            <!-- Question 3 -->
            <div class="mb-10">
              <label class="form-label" id="abused_label">
                Have you ever abused, exploited or neglected a child or vulnerable adult?
              </label><br />

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="abused" value="Yes"
                  [checked]="profileData?.bce_data?.meta?.abused === 'Yes'" class="form-check-input mt-4"
                  id="safeguardingQuestions2" aria-labelledby="abused_label safeguardingQuestions2" />
                <label class="form-check-label" for="safeguardingQuestions2">Yes</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="abused" value="No"
                  [checked]="profileData?.bce_data?.meta?.abused === 'No'" class="form-check-input mt-4"
                  id="safeguardingQuestions_2" aria-labelledby="abused_label safeguardingQuestions_2" />
                <label class="form-check-label" for="safeguardingQuestions_2">No</label>
              </div>
            </div>

            <!-- Question 4 -->
            <div class="mb-10">
              <label class="form-label" id="accused_label">
                Have you ever been accused of offences relating to a child or vulnerable adult?
              </label><br />

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="accused" value="Yes"
                  [checked]="profileData?.bce_data?.meta?.accused === 'Yes'" class="form-check-input mt-4"
                  id="safeguardingQuestions3" aria-labelledby="accused_label safeguardingQuestions3" />
                <label class="form-check-label" for="safeguardingQuestions3">Yes</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="accused" value="No"
                  [checked]="profileData?.bce_data?.meta?.accused === 'No'" class="form-check-input mt-4"
                  id="safeguardingQuestions_3" aria-labelledby="accused_label safeguardingQuestions_3" />
                <label class="form-check-label" for="safeguardingQuestions_3">No</label>
              </div>
            </div>

            <!-- Question 5 -->
            <div class="mb-10">
              <label class="form-label" id="substantiated_label">
                Have you ever been the subject of a substantiated complaint, or convicted of an offence relating to a
                child or vulnerable adult?
              </label><br />

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="substantiated" value="Yes"
                  [checked]="profileData?.bce_data?.meta?.substantiated === 'Yes'" class="form-check-input mt-4"
                  id="safeguardingQuestions4" aria-labelledby="substantiated_label safeguardingQuestions4" />
                <label class="form-check-label" for="safeguardingQuestions4">Yes</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="substantiated" value="No"
                  [checked]="profileData?.bce_data?.meta?.substantiated === 'No'" class="form-check-input mt-4"
                  id="safeguardingQuestions_4" aria-labelledby="substantiated_label safeguardingQuestions_4" />
                <label class="form-check-label" for="safeguardingQuestions_4">No</label>
              </div>
            </div>

            <!-- Question 6 -->
            <div class="mb-10">
              <label class="form-label" id="criminal_label">
                Are you currently the subject of a criminal legal proceeding for an offence relating to a child or
                vulnerable adult?
              </label><br />

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="criminal" value="Yes"
                  [checked]="profileData?.bce_data?.meta?.criminal === 'Yes'" class="form-check-input mt-4"
                  id="safeguardingQuestions5" aria-labelledby="criminal_label safeguardingQuestions5" />
                <label class="form-check-label" for="safeguardingQuestions5">Yes</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="criminal" value="No"
                  [checked]="profileData?.bce_data?.meta?.criminal === 'No'" class="form-check-input mt-4"
                  id="safeguardingQuestions_5" aria-labelledby="criminal_label safeguardingQuestions_5" />
                <label class="form-check-label" for="safeguardingQuestions_5">No</label>
              </div>
            </div>

            <!-- Question 7 -->
            <div class="mb-10">
              <label class="form-label" id="all_questions_label">
                Are the responses you have provided to these questions true and correct?
              </label><br />

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="all_questions" value="Yes"
                  [checked]="profileData?.bce_data?.meta?.all_questions === 'Yes'" class="form-check-input mt-4"
                  id="safeguardingQuestions6" aria-labelledby="all_questions_label safeguardingQuestions6" />
                <label class="form-check-label" for="safeguardingQuestions6">Yes</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" formControlName="all_questions" value="No"
                  [checked]="profileData?.bce_data?.meta?.all_questions === 'No'" class="form-check-input mt-4"
                  id="safeguardingQuestions_6" aria-labelledby="all_questions_label safeguardingQuestions_6" />
                <label class="form-check-label" for="safeguardingQuestions_6">No</label>
              </div>
            </div>

            <div class="modal-footer pt-0">
              <button type="button" class="btn-outline" (click)="goToStep(1)">
                Back
              </button>

              <button type="button" class="btn cc_p_btn fs_13" (click)="goToStep(3)">
                Next
              </button>
            </div>
          </div>

          <!-- Step 3: Multiple Choice Questions -->
          <div *ngIf="step === 3">
            <div class="mb-20">
              <label class="form-label">Teaching levels <span class="text-danger">*</span></label>
              <ng-select [dropdownPosition]="'bottom'" formControlName="teachingLevels" [items]="teachingLevels"
                [multiple]="true" bindLabel="title" bindValue="value" placeholder="Search by level"></ng-select>
            </div>
            <div class="mb-10">
              <label class="form-label">Subjects <span class="text-danger">*</span></label>
              <ng-select [dropdownPosition]="'bottom'" formControlName="subject" [items]="subject" [multiple]="true"
                bindLabel="title" bindValue="value" placeholder="Search by subject"></ng-select>
            </div>
            <div class="modal-footer pt-0">
              <button type="button" class="btn-outline" (click)="goToStep(2)">
                Back
              </button>
              <button type="button" class="btn cc_p_btn fs_13" (click)="submitBceQuestions()">
                Submit
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="bceQuestionsForm.value.bce_work_status === 'N'">
          <div class="modal-footer pt-0">
            <button type="button" class="btn cc_p_btn fs_13" (click)="submitBceQuestions()">
              Submit
            </button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <!-- NSW NESA Details Modal (second popup) -->
  <ng-template #nswNesaModal>
    <div class="modal-header">
      <h5 class="modal-title">Complete the following fields
      </h5>
      <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label class="mr-3">Are you a relief teacher with a NESA ID?
        </label>
        <br>
        <label class="mr-2 mt-3">
          <input style="margin-top: -3px;" class="form-check-input" type="radio" name="hasNesaId"
            [(ngModel)]="nswNesaAnswer" value="Yes"> Yes
        </label>
        <label class="mr-2 mt-3">
          <input style="margin-top: -3px;" class="form-check-input ml-10" type="radio" name="hasNesaId"
            [(ngModel)]="nswNesaAnswer" value="No"> No
        </label>

      </div>
      <div *ngIf="nswNesaAnswer === 'Yes'">
        <div class="form-group mb-2 mt-15">
          <label>First Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="nswNesaFirstName" placeholder="First Name">
        </div>
        <div class="form-group mb-2">
          <label>Last Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="nswNesaLastName" placeholder="Last Name">
        </div>
        <div class="form-group mb-2">
          <label for="date_created" id="date_created_label">Date of Birth <span class="text-danger">*</span></label>
          <div class="d-flex name-input">
            <input ngbDatepicker #d="ngbDatepicker" class="form-control" id="date_created" [(ngModel)]="nswNesaDob"
              [minDate]="{ year: 1950, month: 1, day: 1 }" [maxDate]="{ year: 2026, month: 12, day: 31 }" readonly
              aria-label="Date input, format dd/mm/yyyy" aria-describedby="pending-date-help" autocomplete="off"
              (click)="d.open()" (keydown)="onDateInputKeyDown($event, d)" />
            <span id="pending-date-help" class="sr-only">
              Enter date in format dd/mm/yyyy. Use arrow keys to navigate calendar. Press Enter to open/close picker.
            </span>
            <button class="input-group-text" role="button" (click)="clearSinglePicker()"><i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>NESA ID <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="nswNesaId" placeholder="NESA ID">
        </div>
        @if(!updateNSWVerification){
        <div class="mt-15">
          <div class="form-check mb-1">
            <input type="checkbox" class="form-check-input mt-4" id="nswTnc" [(ngModel)]="nswNesaTnc">
            <label class="form-check-label" for="nswTnc">I confirm that the details entered above are mine and as per
              NSW
              Department of Education records</label>
          </div>
          <div class="form-check mb-2">
            <input type="checkbox" class="form-check-input mt-4" id="nswPrivacy" [(ngModel)]="nswNesaPrivacy">
            <label class="form-check-label " for="nswPrivacy">I provide my consent to ClassCover to share the above
              details
              with NSW Department of Education for verification purposes and to otherwise handle my personal
              information
              in accordance with ClassCover Privacy Policy. I further authorise the NSW Department of Education to
              provide
              personal and employment information about me to ClassCover for the purposes of verification of my
              accreditation status.</label>
          </div>
        </div>
        }
      </div>
      <div *ngIf="nswNesaAnswer === 'No'">
        <p class="mt-10 txt-regular"> Thank you for completing this question. Please hit submit to send your response.
        </p>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-end">
      <button type="button" (click)="submitNSWFinal()" class="btn cc_p_btn fs_13">Submit</button>
      <button type="button" (click)="submitNSW('S')" class="btn-outline fs_13">
        Skip for now
      </button>
    </div>
  </ng-template>
  <ng-template #nswVerificationFormModal>
    <div class="modal-header">
      <h5 class="modal-title">Confirm your teaching status</h5>
      <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body pb-0">
      <p class="txt-regular">
        Do you currently teach in, or are you looking to teach in NSW public
        schools.
      </p>
    </div>
    <hr class="mt-10 mb-10" />
    <div class="modal-footer">
      <button type="button" (click)="submitNSW('Y')" class="btn cc_p_btn fs_13">
        Yes
      </button>
      <button type="button" (click)="submitNSW('N')" class="btn-outline fs_13">
        No
      </button>

      <button type="button" (click)="submitNSW('S')" class="btn-outline fs_13">
        Skip for now
      </button>
    </div>
  </ng-template>

  <!-- QCT Registration COnfirmation -->
  <ng-template #QCTRegistrationConfirmationModal>
    <div class="modal-header">
      <h5 class="modal-title">
        @if(teacherStatus){
        Successfully submitted
        }@else{
        Activation successful
        }
      </h5>
      <!-- <button type="button" class="btn-close" (click)="bsModalRef.hide(); loadProfileAPI()" aria-label="Close"></button> -->
    </div>
    <div class="modal-body pb-0">
      <p class="txt-regular">
        @if(teacherStatus){
        The Queensland Department of Education is currently verifying your profile and updating your contract details
        in
        ClassCover. You will receive an activation email once the process has been successfully completed.
        <br />
        <br />
        Please return to ClassCover once you receive the activation email.
        }@else{
        Congratulations! Your account has been successfully activated.
        <br />
        <br />
        Please complete your profile to start receiving work opportunities. A step by step user guide can be found
        here:
        <a href="https://help.classcover.com.au/en/articles/69084-update-your-profile-details-and-connect-with-schools-queensland-department-of-education"
          target="_blank" class="text-regular-bold clr-cc-vilot text-center c-p">Link</a>
        }
      </p>
    </div>
    <hr class="mt-10 mb-10" />
    <div class="modal-footer">
      <button type="button" class="btn cc_p_btn fs_13" (click)="bsModalRef.hide(); openCompleteProfile(teacherStatus);">
        @if(teacherStatus){
        Ok
        }@else{
        Complete Profile
        }
      </button>
    </div>
  </ng-template>

  <!-- QCT Registration COnfirmation -->
  <ng-template #AccountNotFoundModal>
    <div class="modal-header">
      <h5 class="modal-title">Account not found</h5>
      <!-- <button type="button" class="btn-close" (click)="bsModalRef.hide(); loadProfileAPI()" aria-label="Close"></button> -->
    </div>

    <div class="modal-body">

      <!-- Description -->
      <p class="popup-para-content light2">
        Your profile cannot be activated at this time as your details do not match Departmental records. Please ensure
        you have entered your details exactly as provided in your welcome email or the information used to create
        department profile.
      </p>

      <!-- Details -->
      <div class="details-section mt-20">

        <h6 class="popup-para-sub-header">Details to be sent:</h6>
        <ul class="details-box">
          <li><span class="popup-para-content light2">Legal First Name:</span> <span
              class="popup-para-content">{{QCTRegistrationForm.value.first_name}}</span></li>
          <li><span class="popup-para-content light2">Legal last name:</span> <span
              class="popup-para-content">{{QCTRegistrationForm.value.last_name}}</span></li>
          <li><span class="popup-para-content light2">Date of birth:</span> <span
              class="popup-para-content">{{QCTRegistrationForm.value.dob}}</span></li>
          <li><span class="popup-para-content light2">Employee number:</span> <span
              class="popup-para-content">{{QCTRegistrationForm.value.employee_number}}</span></li>
          <li><span class="popup-para-content light2">QCT number:</span> <span
              class="popup-para-content">{{QCTRegistrationForm.value.qct_number}}</span></li>
        </ul>

      </div>

      <!-- Footer message -->
      <p class="popup-para-content mt-10">
        If you require additional support from the Queensland Department of Education to validate your account, please
        click "Contact Support" button and our support team will be in touch with you.
      </p>

      <!-- What happens next -->
      <div class="info-box">
        <h6 class="popup-para-sub-header">What happens next:</h6>
        <ul>
          <li class="popup-para-content light2">Your details will be sent to the Support team.</li>
          <li class="popup-para-content light2">They'll verify your information and contact you.</li>
          <li class="popup-para-content light2">Your profile will be unlocked once verified.</li>
        </ul>
      </div>
      <p class="popup-para-content mt-10">
        Once the issue has been resolved with the Support Team, please update your ClassCover profile using the
        details
        provided to finalise your verification with the Department.
      </p>

    </div>
    <div class="modal-footer justify-content-end req-tracer-footer">
      <button type="button" class="me-3" (click)=" bsModalRef.hide(); loadProfileAPI(false ,'loadMixpanel')">
        Skip for now
      </button>
      <button type="button" (click)="ReqTracerHelper()" class="btn cc_p_btn fs_13">Contact Support</button>
    </div>
  </ng-template>

  <!-- QCT Registration CConflict -->
  <ng-template #AccountConflictModal>
    <div class="modal-header">
      <h5 class="modal-title">Existing account found</h5>
      <!-- <button type="button" class="btn-close" (click)="bsModalRef.hide(); loadProfileAPI()" aria-label="Close"></button> -->
    </div>

    <div class="modal-body">
      <!-- Main message -->
      <p class="account-not-found-text mb-10 mt-20">
        An account with these details is already registered and verified with Qld DoE.
      </p>
      <p class="account-not-found-text mb-20">
        You must log in using your existing ClassCover account to proceed.<br />
        If you’re unable to access your account, please contact the ClassCover Support Team at <a
          href="mailto:support@classcover.com.au">support&#64;classcover.com.au</a>
      </p>
    </div>
    <div class="modal-footer justify-content-end">
      <button type="button" (click)="bsModalRef.hide(); loadProfileAPI()" class="btn cc_p_btn fs_13">Ok</button>
    </div>
  </ng-template>


  <!-- QCT Registration Form -->
  <ng-template #QCTRegistrationFormModal>
    <div class="modal-header">
      <h5 class="modal-title">
        Please enter your details to verify with the Department of Education using the information provided on your
        welcome email or information used to create the department profile.
      </h5>
      <button type="button" class="btn-close" (click)="closeQldModal()" aria-label="Close"></button>
    </div>
    <div class="modal-body pb-0">
      <div class="row">
        <form [formGroup]="QCTRegistrationForm">
          @if(attemptCount > 0 && attemptCount < 3) { <div class="col-lg-12 col-md-12 mt-15">
            <div class="alert alert-danger border-danger rounded p-3">
              <p class="mb-1 text-danger">
                Account not found
              </p>
              <p class="mt-8 account-not-found-text mb-8">
                Your profile cannot be activated at this time as your details do not match Departmental records.
                Please
                ensure you have entered your details exactly as provided in your welcome email.
              </p>
              <p>
                Attempt {{attemptCount}} of 3
              </p>
            </div>
      </div>
      }
      <!-- Legal first name -->
      <div class="col-lg-12 col-md-12 mt-15">
        <label class="form-label">Legal First Name</label>
        <input onlyAlphabetWithSpace formControlName="first_name" type="text" placeholder="Type here"
          class="form-control" />
        <div class="text-danger" *ngIf="isInvalid('first_name')">
          Legal first name is required
        </div>
      </div>
      <!-- Legal last name -->
      <div class="col-lg-12 col-md-12 mt-15">
        <label class="form-label">Legal last name</label>
        <input onlyAlphabetWithSpace formControlName="last_name" type="text" placeholder="Type here"
          class="form-control" />
        <div class="text-danger" *ngIf="isInvalid('last_name')">
          Legal last name is required
        </div>
      </div>

      <!-- Date of Birth -->
      <div class="col-lg-12 col-md-12 mt-15">
        <label class="form-label">Date of Birth</label>
        <input type="text" placeholder="Select date" class="form-control" bsDatepicker formControlName="dob" [bsConfig]="{
              dateInputFormat: 'DD/MM/YYYY',
              containerClass: 'theme-red',
              showWeekNumbers: false,
              adaptivePosition: true
            }">
        <div class="text-danger" *ngIf="isInvalid('dob')">
          Date of birth is required
        </div>
      </div>

      <!-- Employee Number -->
      <div class="col-lg-12 col-md-12 mt-15 eq-input-group">
        <label class="form-label" for="employee_number">Employee number</label>
        <input id="employee_number" formControlName="employee_number" onlyNumbers type="text" class="form-control"
          placeholder="Employee number" aria-label="Employee number" aria-describedby="eq-addon">
        <!-- <div
          class="input-group-append"
          (click)="!EQVerificationStatus ? checkEqId() : ''"
          style="cursor: pointer;"
        >
          @if(!EQVerificationStatus){
        <span class="input-group-text" id="eq-addon">Verify</span>
          }@else{
        <span class="input-group-text verified" id="eq-addon"><i class="bi bi-check2-circle me-1"></i> Verified</span>
          }
        </div> -->
        <div class="text-danger"
          *ngIf="isInvalid('employee_number') && QCTRegistrationForm.get('employee_number')?.touched">
          Enter valid Employee number
        </div>
      </div>

      <!-- QCT Number -->
      <div class="col-lg-12 col-md-12 mt-15">
        <label class="form-label">QCT number</label>
        <input formControlName="qct_number" type="text" placeholder="Type here" onlyNumbers class="form-control" />
        <div class="text-danger" *ngIf="isInvalid('qct_number') && QCTRegistrationForm.get('qct_number')?.touched">
          Enter valid QCT number
        </div>
      </div>

      <!-- Confirmation Checkbox -->
      <div class="col-lg-12 col-md-12 mt-15">
        <div class="form-check">
          <input appFocu appClick type="checkbox" id="QLD_confirmation" formControlName="qld_confirmation"
            class="form-check-input c-p mt-4" />
          <label class="form-check-label c-p" for="QLD_confirmation">
            I confirm that the details entered above are mine and as per registered profile with the Department of
            Education.
          </label>
        </div>
        <div class="text-danger" *ngIf="isInvalid('qld_confirmation')">
          You must confirm your details
        </div>
      </div>

      <!-- Consent Checkbox -->
      <div class="col-lg-12 col-md-12 mt-15">
        <div class="form-check">
          <input appFocu appClick type="checkbox" id="QLD_verify_consent" formControlName="qld_verify_consent"
            class="form-check-input c-p mt-4" />
          <label class="form-check-label c-p" for="QLD_verify_consent">
            I provide my consent for ClassCover to share the above details with the Queensland Department of Education
            for verification purposes and to otherwise handle my personal information in accordance with the <a
              class="u_l a_href_ul" href="https://www.classcover.com.au/privacy-policy/"
              target="_blank">https://www.classcover.com.au/privacy-policy/</a> This information is collected in
            accordance with the Information Privacy Act 2009 (QLD).
            <br />
            <br />
            If  you do not provide your personal information, we will be unable to validate and activate your account,
            and you will not be able to work for the Queensland Department of Education as a relief teacher.
            <br />
            <br />
            To update your personal information or make a privacy complaint, visit the Queensland Department of
            Education website <a class="u_l a_href_ul" href="https://qed.qld.gov.au/privacy"
              target="_blank">https://qed.qld.gov.au/privacy</a>
          </label>

        </div>
        <div class="text-danger" *ngIf="isInvalid('qld_verify_consent')">
          You must provide your consent
        </div>
      </div>
      </form>

    </div>
</div>
<hr class="mt-10 mb-10" />
<!-- @if(EQVerificationStatus) { -->
<div class="modal-footer">
  <button type="button" (click)="submitHasQCTRegistrationForm()" class="btn cc_p_btn fs_13"
    [disabled]="!QCTRegistrationForm.valid">
    Submit
  </button>
</div>
<!-- } -->
</ng-template>
<ng-template #bookingsOnboardingModal>
  <div class="modal-header">
    <h5 class="modal-title">Turn Bookings On</h5>

    @if(using_cc_to_B) {
    <span class="user-title bookings-tag">Bookings on</span>
    } @else {
    <span class="user-title bookings-tag-off">Bookings off</span>
    }

  </div>
  <div class="modal-body pb-0">
    <div class="col-md-12 col-lg-12 mt-15">
      <div class="col-md-12 col-sm-12">
        <p class="txt-regular fs-14">
          Toggle on to be available for casual bookings. Toggle off to
          hide your profile and stop new booking requests.
        </p>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="job__alerts switch-green d-flex mt-10">
          <div class="mr-10">
            <div class="form-check form-switch  p-0 mt-4">
              <input type="checkbox" role="switch" id="availability-switch-1"
                class="form-check-input delay-send form__switch_cc ml-0 c-p" name="availabilitySwitch1"
                name="turnOnTeacherPortfolio" [(ngModel)]="using_cc_to_B" [checked]="using_cc_to_B" />
            </div>
          </div>
          @if(using_cc_to_B) {
          <p class="txt-regular mt-6">
            Schools can find and book you
          </p>
          } @else {
          <p class="txt-regular">
            You are hidden from bookings but can still access ClassCover Jobs and
            ClassCover Learn
          </p>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer pt-0">
    <button type="button" class="btn cc_p_btn fs_13" (click)="saveBookingsOnboarding()">Next</button>
  </div>
</ng-template>
<ng-template #videoIntroModal>
  <form [formGroup]="videoIntroForm">
    <div class="modal-header">
      <h4 class="model_headings mb-0" id="editProfileInformationModal">
        Add a short video introducing yourself to schools that might want to work with you
      </h4>
      <button type="button" (click)="this.bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
    </div>
    <div class="modal-body pb-0">
      <div class="col-lg-12">
        <label>Link to your video (youtube or vimeo)</label>
        <input type="text" placeholder="Ex: https://www.youtube.com/watch?v=dWgXwCeA" formControlName="video_intro_link"
          class="form-control" (input)="onVideoIntroLinkChange()">
        <ng-container *ngIf="videoMeta">
          <app-video-player [videoMeta]="videoMeta" [videoError]="videoError"></app-video-player>
        </ng-container>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <button type="button" class="btn cc_p_btn fs-13" [disabled]="!videoMeta || !!videoError"
        (click)="saveVideoIntro()">
        Save
      </button>
    </div>
  </form>
</ng-template>
<ng-template #introVideoRemoveConfirmation>
  <form>
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel">Confirmation</h4>
      <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          <p class="txt-regular">
            Are you sure you want to remove {{ introVideo?.url }}?
          </p>
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <button (click)="removeVideoIntro()" type="button" class="btn cc_p_btn fs_13">
        Confirm
      </button>
    </div>
  </form>
</ng-template>

<ng-template #QLDProfileIncompleteModal>
  <form>
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel">Incomplete account</h4>
      <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          <p class="txt-regular">
            Your account appears to be incomplete. To be eligible for school booking requests, please update your
            ClassCover profle. A step by step user guide can be found here:
            <a href="https://help.classcover.com.au/en/articles/69084-update-your-profile-details-and-connect-with-schools-queensland-department-of-education"
              target="_blank" class="text-regular-bold clr-cc-vilot text-center c-p">Link</a>
            <br />
            Once your account is complete, you'll be ready to receive booking requests through ClassCover.
          </p>
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <button (click)="bsModalRef.hide()" type="button" class="btn cc_p_btn fs_13">
        Okay
      </button>
    </div>
  </form>
</ng-template>